<template>
  <div class="forms-elements print-temp">
    <div class="vertical-sidenav sidenav-container-layout">
      <!-- Sidenav for Print Template -->
      <div class="sidenav">
        <b-nav
          vertical
          class="side-nav-content custom-print-sidenav"
          style="width: 400px !important;"
        >
          <div class="sidenav-container-layout">
            <div>
              <!-- options -->
              <b-tabs v-model="tabIndex" class="nav-cols custom-line-tab border-tab mt-2">
                <!-- Template Tab -->
                <b-tab title="Template" class="px-pad py-3 mt-2 mr-4" active v-if="temp_prop">
                  <b-form data-vv-scope="temp_prop_tab">
                    <b-row class="ml-1">
                      <b-col class="px-0">
                        <!-- Template Name -->
                        <b-form-group
                          :label="'Template Name'"
                          label-class="required "
                          label-for="temp_name"
                          class="mb-4"
                        >
                          <b-form-input
                            disabled
                            name="temp_name"
                            :class="{'is-invalid':temp_has_error&&errors.has('temp_prop_tab.temp_name')}"
                            v-validate="'required|max:50'"
                            v-model="temp_prop.temp_name"
                          />
                        </b-form-group>
                        <!-- Paper Size -->
                        <b-form-group
                          horizontal
                          label="Paper Size"
                          label-for="paper_size"
                          class="mb-4"
                          label-class
                        >
                          <b-form-radio-group
                            class="mt-1"
                            v-model="temp_prop.paper_size"
                            :options="papersize"
                          />
                        </b-form-group>
                        <!-- Orientation -->
                        <b-form-group
                          horizontal
                          label="Orientation"
                          label-for="orientation"
                          class="mb-4"
                          label-class
                        >
                          <b-form-radio-group
                            class="mt-1"
                            v-model="temp_prop.orientation"
                            :options="orientation"
                          />
                        </b-form-group>
                        <!-- Margins -->
                        <b-form-group
                          :label="'Margins (in Inches)'"
                          label-class="required "
                          label-for="margins"
                          class="mb-4"
                        >
                          <div style="display:inline-flex">
                            <!-- Margin Top -->
                            <b-col sm="3" class="pl-0 pr-2">
                              <b-form-input
                                name="margin_top"
                                :class="{'is-invalid':temp_has_error&&errors.has('temp_prop_tab.margin_top')}"
                                v-validate="'min_value:0'"
                                v-model="temp_prop.margin_top"
                              />
                              <small class="text-muted">Top</small>
                            </b-col>
                            <!-- Margin bottom -->
                            <b-col sm="3" class="pl-0 pr-2">
                              <b-form-input
                                name="margin_bottom"
                                :class="{'is-invalid':temp_has_error&&errors.has('temp_prop_tab.margin_bottom')}"
                                v-validate="'min_value:0'"
                                v-model="temp_prop.margin_bottom"
                              />
                              <small class="text-muted">Bottom</small>
                            </b-col>
                            <!--Margin left  -->
                            <b-col sm="3" class="pl-0 pr-2">
                              <b-form-input
                                name="margin_left"
                                :class="{'is-invalid':temp_has_error&&errors.has('temp_prop_tab.margin_left')}"
                                v-validate="'min_value:0'"
                                v-model="temp_prop.margin_left"
                              />
                              <small class="text-muted">Left</small>
                            </b-col>
                            <!-- Margin right -->
                            <b-col sm="3" class="pl-0 pr-0">
                              <b-form-input
                                name="margin_right"
                                :class="{'is-invalid':temp_has_error&&errors.has('temp_prop_tab.margin_right')}"
                                v-validate="'min_value:0'"
                                v-model="temp_prop.margin_right"
                              />
                              <small class="text-muted">Right</small>
                            </b-col>
                          </div>
                        </b-form-group>
                        <b-form-group
                          v-if="temp_prop.hasOwnProperty('bg_color')"
                          class="mb-4"
                          horizontal
                          label="Background Color"
                          label-for="temp_bg_color"
                          :label-cols="5"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <!-- Show Field -->
                            <div class="abc-checkbox" style="padding-top:5px;">
                              <input
                                type="checkbox"
                                id="temp_bg_color"
                                :true-value="1"
                                :false-value="0"
                                v-model="temp_prop.bg_color.show"
                              />
                              <label for="temp_bg_color"></label>
                            </div>
                            <!-- Color Picker -->
                            <input
                              type="text"
                              class="form-control"
                              disabled
                              :value="temp_prop.bg_color.value.hex"
                            />
                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_17 }"
                              v-model="temp_prop.bg_color.value"
                            />
                            <b-input-group-text
                              @click="colorPickerActive.color_17 = !colorPickerActive.color_17"
                              slot="append"
                              style="padding:5px !important;"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': temp_prop.bg_color.value.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>
                        <b-form-group
                          v-if="temp_prop.hasOwnProperty('label_color')"
                          class="mb-4"
                          horizontal
                          label="Label Color"
                          label-for="temp_label_color"
                          :label-cols="5"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <!-- Show Field -->

                            <!-- Color Picker -->
                            <input
                              type="text"
                              class="form-control"
                              disabled
                              :value="temp_prop.label_color.hex"
                            />
                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_18 }"
                              v-model="temp_prop.label_color"
                            />
                            <b-input-group-text
                              @click="colorPickerActive.color_18 = !colorPickerActive.color_18"
                              slot="append"
                              style="padding:5px !important;"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': temp_prop.label_color.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>
                        <b-form-group
                          v-if="temp_prop.hasOwnProperty('font_color')"
                          class="mb-4"
                          horizontal
                          label="Font Color"
                          label-for="temp_font_color"
                          :label-cols="5"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <!-- Show Field -->

                            <!-- Color Picker -->
                            <input
                              type="text"
                              class="form-control"
                              disabled
                              :value="temp_prop.font_color.hex"
                            />
                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_19 }"
                              v-model="temp_prop.font_color"
                            />
                            <b-input-group-text
                              @click="colorPickerActive.color_19 = !colorPickerActive.color_19"
                              slot="append"
                              style="padding:5px !important;"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': temp_prop.font_color.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>
                        <b-form-group
                          v-if="temp_prop.hasOwnProperty('font_size')"
                          horizontal
                          label="Font Size"
                          label-for="temp_font_size"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-input-group append="pt">
                            <b-form-input
                              name="temp_font_size"
                              :class="{'is-invalid':header_has_error&&errors.has('temp_prop_tab.temp_font_size')}"
                              v-validate="'min_value:0|max_value:18'"
                              v-model="temp_prop.font_size"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-tab>
                <!-- Header Tab -->
                <b-tab title="Header" class="px-pad py-3 mt-2 mr-4" v-if="header_prop"> 
                  <b-form data-vv-scope="header_prop_tab">
                    <b-row class="ml-1">
                      <b-col class="px-0">
                        <!-- Showing Organization Logo -->
                        <b-form-group class="mb-4" v-if="header_prop.hasOwnProperty('show_logo')">
                          <div class="abc-checkbox">
                            <input
                              type="checkbox"
                              id="org_logo_show"
                              :true-value="1"
                              :false-value="0"
                              v-model="header_prop.show_logo"
                            />
                            <label
                              for="org_logo_show"
                              style="padding-top:2px;"
                            >Showing Organization Logo</label>
                          </div>
                        </b-form-group>
                        <!-- resize logo -->
                        <b-form-group
                          class="mb-4"
                          v-if="header_prop.show_logo==1"
                          label="Resize Logo"
                          horizontal
                          label-for="resize_logo"
                          :label-cols="4"
                        >
                          <b-form-slider
                            @change="findHieght($event)"
                            v-model="header_prop.logo_width"
                            :value="150"
                            :max="300"
                            :min="50"
                          />
                        </b-form-group>
                        <!-- Show Organization Name -->
                        <b-form-group class="mb-4" v-if="header_prop.hasOwnProperty('show_org_name')">
                          <div class="abc-checkbox">
                            <input
                              type="checkbox"
                              id="org_name_show"
                              :true-value="1"
                              :false-value="0"
                              v-model="header_prop.show_org_name"
                            />
                            <label
                              for="org_name_show"
                              style="padding-top:2px;"
                            >Show Organization Name</label>
                          </div>
                        </b-form-group>
                        <!-- Show Organization Address -->
                        <b-form-group class="mb-4" v-if="header_prop.hasOwnProperty('show_org_addr')">
                          <div class="abc-checkbox">
                            <input
                              type="checkbox"
                              id="org_addr_show"
                              :true-value="1"
                              :false-value="0"
                              v-model="header_prop.show_org_addr"
                            />
                            <label
                              for="org_addr_show"
                              style="padding-top:2px;"
                            >Show Organization Address</label>
                          </div>
                        </b-form-group>
                        <!-- Show Document Title -->
                        <b-form-group class="mb-4" v-if="header_prop.hasOwnProperty('show_doc_title')">
                          <div class="abc-checkbox">
                            <input
                              type="checkbox"
                              id="doc_title_show"
                              :true-value="1"
                              :false-value="0"
                              v-model="header_prop.show_doc_title"
                            />
                            <label for="doc_title_show" style="padding-top:2px;">Show Document Title</label>
                          </div>
                        </b-form-group>
                        <!-- Document Title Label -->
                        <b-form-group class="mb-4" v-if="header_prop.hasOwnProperty('doc_title')">
                          <b-form-input
                            v-model="header_prop.doc_title"
                            name="doc_title_label"
                            v-validate="'max:50'"
                            :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.doc_title_label')}"
                          ></b-form-input>
                        </b-form-group>
                        <!-- Header Background -->
                        <b-form-group
                          class="pb-1 mb-4"
                          label="Background Color"
                          label-for="head_bg_color"
                          :label-cols="5"
                          v-if="header_prop.hasOwnProperty('is_header_bg_color')"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <div class="abc-checkbox" style="padding-top:5px;">
                              <input
                                type="checkbox"
                                id="head_bg_color"
                                :true-value="1"
                                :false-value="0"
                                v-model="header_prop.is_header_bg_color"
                              />
                              <label for="head_bg_color"></label>
                            </div>
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              :value="header_prop.header_bg_color.hex"
                            />

                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_1 }"
                              v-model="header_prop.header_bg_color"
                            />

                            <b-input-group-text
                              @click="colorPickerActive.color_1=!colorPickerActive.color_1"
                              slot="append"
                              style="padding:5px !important;"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': header_prop.header_bg_color.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <!-- Document Details -->
                    <b-row class="my-2 ml-0" v-if="menu_id!=11&&menu_id!=13">
                      <b-col class="px-0">
                        <h6 class="mb-3 h6-lg text-link">Document Title</h6>
                        <!-- Document Title Font Size -->
                        <b-form-group
                          horizontal
                          label="Font Size"
                          label-for="doc_title_size"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-input-group append="pt">
                            <b-form-input
                              name="doc_font_size"
                              :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.doc_font_size')}"
                              v-validate="'min_value:0|max_value:18'"
                              v-model="header_prop.doc_title_size"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                        <!-- Document Title Font Color -->
                        <b-form-group
                          class="mb-4"
                          horizontal
                          label="Font Color"
                          label-for="doc_title_color"
                          :label-cols="5"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              :value="header_prop.doc_title_color.hex"
                            />
                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_2 }"
                              v-model="header_prop.doc_title_color"
                            />
                            <b-input-group-text
                              @click="colorPickerActive.color_2 = !colorPickerActive.color_2"
                              slot="append"
                              style="padding:5px !important;"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': header_prop.doc_title_color.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <!-- Organization Details -->
                    <b-row class="my-2 ml-0">
                      <b-col class="px-0">
                        <h6 class="mb-3 h6-lg text-link">Organization</h6>

                        <!-- Organization Name Color -->
                        <b-form-group
                          horizontal
                          label="Name Color"
                          label-for="org_name_color"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <input
                              type="text"
                              class="form-control"
                              :value="header_prop.org_name_color.hex"
                              disabled
                            />
                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_3 }"
                              v-model="header_prop.org_name_color"
                            />
                            <b-input-group-text
                              style="padding:5px !important;"
                              @click="colorPickerActive.color_3 = !colorPickerActive.color_3"
                              slot="append"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': header_prop.org_name_color.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>

                        <!-- Organization Name Size -->
                        <b-form-group
                          horizontal
                          label="Name Size"
                          label-for="name_size"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-input-group append="pt">
                            <b-form-input
                              name="org_name_size"
                              :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.org_name_size')}"
                              v-validate="'min_value:0|max_value:18'"
                              v-model="header_prop.org_name_size"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                        <!-- Organization Phone -->
                        <b-form-group
                          horizontal
                          label="Phone"
                          label-for="phone"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-form-input
                            name="org_phone_no"
                            :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.org_phone_no')}"
                            v-validate="'max:50'"
                            v-model="header_prop.phone"
                          ></b-form-input>
                        </b-form-group>
                        <!-- Organization Fax -->
                        <b-form-group
                          v-if="header_prop.hasOwnProperty('fax')"
                          horizontal
                          label="Fax"
                          label-for="fax"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-form-input
                            name="org_fax_no"
                            :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.org_fax_no')}"
                            v-validate="'max:50'"
                            v-model="header_prop.fax"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <!-- Customer Name Details -->
                    <b-row class="my-2 ml-0" v-if="menu_id!=11&&menu_id!=13">
                      <b-col class="px-0">
                        <h6
                          class="mb-3 h6-lg text-link"
                          v-if="this.menu_id!=6&&this.menu_id!=7&&this.menu_id!=8&&this.menu_id!=9"
                        >Customer Name</h6>
                        <h6 class="mb-3 h6-lg text-link" v-else>Vendor Name</h6>

                        <!-- Customer Name Color -->
                        <b-form-group
                          horizontal
                          label="Font Color"
                          label-for="cus_name_color"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <input
                              type="text"
                              class="form-control"
                              :value="header_prop.cus_name_color.hex"
                              disabled
                            />
                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_4 }"
                              v-model="header_prop.cus_name_color"
                            />
                            <b-input-group-text
                              style="padding:5px !important;"
                              @click="colorPickerActive.color_4 = !colorPickerActive.color_4"
                              slot="append"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': header_prop.cus_name_color.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>

                        <!-- Customer name font -->
                        <b-form-group
                          horizontal
                          label="Font Size"
                          label-for="cus_name_size"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-input-group append="pt">
                            <b-form-input
                              name="cus_name_font_size"
                              :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.cus_name_font_size')}"
                              v-validate="'min_value:0|max_value:18'"
                              v-model="header_prop.cus_name_size"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <!-- Document Information -->
                    <b-row class="my-2 ml-0" v-if="menu_id!=11&&menu_id!=13">
                      <b-col class="px-0">
                        <h6 class="mb-3 h6-lg text-link">Document Information</h6>
                        <b-form-group class="mb-4">
                          <!-- Number Field -->
                          <b-row class="pb-2" v-if="header_prop.hasOwnProperty('doc_no')">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Number Label -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="doc_no"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.doc_no.show"
                                />
                                <label for="doc_no" style="padding-top:2px;">Number Field</label>
                              </div>
                            </b-col>

                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Number Label -->
                              <b-form-input
                                name="doc_no_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.doc_no_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.doc_no.show==0"
                                v-model="header_prop.doc_no.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <!-- Date Field -->
                          <b-row class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Date Label -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="doc_date"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.doc_date.show"
                                />
                                <label for="doc_date" style="padding-top:2px;">Date Field</label>
                              </div>
                            </b-col>

                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Date Label -->
                              <b-form-input
                                name="doc_date_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.doc_date_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.doc_date.show==0"
                                v-model="header_prop.doc_date.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <!-- Payment terms -->
                          <b-row class="pb-2" v-if="header_prop.hasOwnProperty('payment_terms')&&menu_id!=15">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show payment terms Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="payment_terms"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.payment_terms.show"
                                />
                                <label for="payment_terms" style="padding-top:2px;">Terms</label>
                              </div>
                            </b-col>
                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Due Date Label -->
                              <b-form-input
                                name="payment_terms_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.payment_terms_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.payment_terms.show==0"
                                v-model="header_prop.payment_terms.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <!-- Due Date Field -->
                          <b-row class="pb-2" v-if="menu_id!=15">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Due Date Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="doc_due_date"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.doc_due_date.show"
                                />
                                <label
                                  for="doc_due_date"
                                  style="padding-top:2px;"
                                >{{menu_id==1 || menu_id==5|| menu_id==8 || menu_id==7?'Due Date':menu_id==2 || menu_id==4||menu_id==6 ?'Expiry Date':menu_id==3?'Invoice Date':menu_id==9?'Bill Date':'Order Date'}}</label>
                              </div>
                            </b-col>
                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Due Date Label -->
                              <b-form-input
                                name="doc_due_date_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.doc_due_date_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.doc_due_date.show==0"
                                v-model="header_prop.doc_due_date.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <!-- Shipment Date Field -->
                          <b-row
                            class="pb-2"
                            v-if="header_prop.hasOwnProperty('doc_shipment_date')&&menu_id!=15"
                          >
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Shipment Date Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="doc_shipment_date"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.doc_shipment_date.show"
                                />
                                <label
                                  for="doc_shipment_date"
                                  style="padding-top:2px;"
                                >Shipment Date</label>
                              </div>
                            </b-col>
                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Due Date Label -->
                              <b-form-input
                                name="doc_shipment_date_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.doc_shipment_date_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.doc_shipment_date.show==0"
                                v-model="header_prop.doc_shipment_date.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <!-- Number(reference) Field -->
                          <b-row class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Number(reference) Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="doc_ref_no"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.doc_ref_no.show"
                                />
                                <label
                                  for="doc_ref_no"
                                  style="padding-top:2px;"
                                >{{ menu_id == 5|| menu_id == 10|| menu_id == 15 ? 'Reference Field' : 'Ref No.' }}</label>
                              </div>
                            </b-col>
                            <!-- Number Label -->
                            <b-col sm="7" style="padding-left: 7px !important">
                              <b-form-input
                                name="doc_ref_no_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.doc_ref_no_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.doc_ref_no.show==0"
                                v-model="header_prop.doc_ref_no.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <!-- Salesperson Field  -->
                          <b-row v-if="menu_id <=5 || menu_id ==10" class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Salesperson Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="sales_person"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.doc_sales_person.show"
                                />
                                <label
                                  for="sales_person"
                                  style="padding-top:2px;"
                                >{{ menu_id == 5||menu_id == 6 || menu_id == 10 ? 'Total Qty' : 'Salesperson' }}</label>
                              </div>
                            </b-col>
                            <!-- Salesperson Label -->
                            <b-col sm="7" style="padding-left: 7px !important">
                              <b-form-input
                                name="sales_person_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.sales_person_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.doc_sales_person.show==0"
                                v-model="header_prop.doc_sales_person.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <!-- Project Field  -->
                          <b-row v-if="header_prop.hasOwnProperty('doc_proj_name')" class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Project Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="doc_proj_name"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.doc_proj_name.show"
                                />
                                <label for="doc_proj_name" style="padding-top:2px;">Project</label>
                              </div>
                            </b-col>
                            <!-- Project Label -->
                            <b-col sm="7" style="padding-left: 7px !important">
                              <b-form-input
                                name="doc_proj_name_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.doc_proj_name_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.doc_proj_name.show==0"
                                v-model="header_prop.doc_proj_name.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <!-- E-way-no Field  -->
                          <b-row v-if="header_prop.hasOwnProperty('doc_eway_no')&&menu_id!=15" class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Project Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="doc_eway_no"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.doc_eway_no.show"
                                />
                                <label for="doc_eway_no" style="padding-top:2px;">e-Way Bill Number</label>
                              </div>
                            </b-col>
                            <!-- E-way-no Label -->
                            <b-col sm="7" style="padding-left: 7px !important">
                              <b-form-input
                                name="doc_eway_no_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.doc_eway_no_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.doc_eway_no.show==0"
                                v-model="header_prop.doc_eway_no.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <!-- SShipping charge Field  -->
                          <b-row v-if="menu_id==10" class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show SShipping charge -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="ship_charge"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.doc_ship_charge.show"
                                />
                                <label for="ship_charge" style="padding-top:2px;">Shipping Charge</label>
                              </div>
                            </b-col>
                            <!-- Shipping charge -->
                            <b-col sm="7" style="padding-left: 7px !important">
                              <b-form-input
                                name="ship_charge_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.ship_charge_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.doc_ship_charge.show==0"
                                v-model="header_prop.doc_ship_charge.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <!-- Track No Field  -->
                          <b-row v-if="menu_id==10" class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Track No  -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="ship_track"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.doc_ship_track.show"
                                />
                                <label for="ship_track" style="padding-top:2px;">Track No</label>
                              </div>
                            </b-col>
                            <!-- Shipping charge -->
                            <b-col sm="7" style="padding-left: 7px !important">
                              <b-form-input
                                name="ship_track_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.ship_track_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.doc_ship_track.show==0"
                                v-model="header_prop.doc_ship_track.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <!-- Bill To Filed -->
                          <b-row class="pb-2" v-if="menu_id != 10">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Bill To  -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="doc_bill_to"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.doc_bill_to.show"
                                />
                                <label for="doc_bill_to" style="padding-top:2px;">Bill To</label>
                              </div>
                            </b-col>
                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Bill To Label -->
                              <b-form-input
                                name="doc_bill_to_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.doc_bill_to_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.doc_bill_to.show==0"
                                v-model="header_prop.doc_bill_to.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <b-form-group v-if="menu_id==3">
                            <div class="abc-checkbox">
                              <input
                                type="checkbox"
                                id="show_inv_no"
                                :true-value="1"
                                :false-value="0"
                                v-model="header_prop.show_inv_no"
                              />
                              <label for="show_inv_no" style="padding-top:2px;">Show Invoice Number</label>
                            </div>
                          </b-form-group>
                          <!-- Ship To Field -->
                          <b-row v-if="menu_id!=3&&menu_id!=15" class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Ship to -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="doc_ship_to"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.doc_ship_to.show"
                                />
                                <label for="doc_ship_to" style="padding-top:2px;">Ship To</label>
                              </div>
                            </b-col>
                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Ship To Label -->
                              <b-form-input
                                name="doc_ship_to_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.doc_ship_to_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.doc_ship_to.show==0"
                                v-model="header_prop.doc_ship_to.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <!-- Place of Supply Field -->
                          <b-row v-if="menu_id!=3&&menu_id!=15" class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Place of Supply -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="doc_place_supply"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.doc_place_supply.show"
                                />
                                <label
                                  for="doc_place_supply"
                                  style="padding-top:2px;"
                                >{{menu_id==7 || menu_id == 8 || menu_id==9?'Source of Supply':'Place of Supply'}}</label>
                              </div>
                            </b-col>
                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Place of Supply Label -->
                              <b-form-input
                                name="doc_place_supply_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.doc_place_supply_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.doc_place_supply.show==0"
                                v-model="header_prop.doc_place_supply.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <!-- Invoice Tag Field -->
                          <b-row class="pb-2" v-if="menu_id != 5&&menu_id!=15 ">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Invoice Tag -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="doc_inv_tag_label"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.doc_inv_tag.show"
                                />
                                <label for="doc_inv_tag_label" style="padding-top:2px;">
                                  <!-- {{menu_id==1?'Invoice Tags':(menu_id==2?'Quotation Tags':(menu_id==10?'Shippment Carrier':(menu_id==4?'Order Tags':(menu_id==6?'Purchase tags':'Credit Tags'))))}} -->
                                  <span>{{id==19?'Shippment Carrier':id==11||id==12||id==16?'Order Tags':id==1||id==2?'Invoice Tags':id==4||id==5?'Quotation Tags':id==8||id==9||id==18?'Credit Tags':id=17?'Bill Tags':'Tags'}}</span>
                                </label>
                              </div>
                            </b-col>
                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Place of Invoice Tags -->
                              <b-form-input
                                name="doc_inv_tag_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.doc_inv_tag_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.doc_inv_tag.show==0"
                                v-model="header_prop.doc_inv_tag.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <!-- Status Stamp -->
                          <b-row v-if="menu_id!=3" class="pb-2">
                            <b-col sm="7" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Status Stamp -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="status_stamp"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.show_status_stamp"
                                />
                                <label for="status_stamp" style="padding-top:2px;">Show Status Stamp</label>
                              </div>
                            </b-col>
                          </b-row>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-tab>
                <!-- Item Properties -->
                <b-tab title="Product" class="px-pad py-3 mt-2 mr-4" v-if="item_prop">
                  <b-row class="ml-0">
                    <b-tabs
                      v-model="itemTabIndex"
                      class="nav-cols custom-line-tab button-nav button-tab"
                    >
                      <!-- Label Tab -->
                      <b-tab title="Labels" class="px-0" active>
                        <b-form data-vv-scope="item_label_prop_tab ">
                          <!-- Header For Fields -->
                          <b-row class="mx-1 mt-4">
                            <b-col sm="5" class="p-0" style="padding-top: 7px !important;"></b-col>
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-2">
                                  <small>Width(%)</small>
                                </b-col>
                                <b-col sm="8" class="px-2">
                                  <small>Label</small>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <!-- Line Item No Field -->
                          <b-row class="pb-2 mx-1 mt-3">
                            <b-col sm="5" class="px-1" style="padding-top: 7px !important;">
                              <!-- Show field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="line_item_no"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.item_no.show"
                                />
                                <label
                                  for="line_item_no"
                                  style="padding-top:2px;"
                                >Line Product Number</label>
                              </div>
                            </b-col>
                            <!-- Width and Label values -->
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-1">
                                  <b-form-input
                                    name="item_no_width"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_no_width')}"
                                    v-validate="'max_value:100'"
                                    :disabled="item_prop.label.item_no.show==0"
                                    v-model="item_prop.label.item_no.width"
                                  ></b-form-input>
                                </b-col>
                                <b-col sm="8" class="px-1">
                                  <b-form-input
                                    name="item_no_label"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_no_label')}"
                                    v-validate="'max:50'"
                                    :disabled="item_prop.label.item_no.show==0"
                                    v-model="item_prop.label.item_no.label"
                                  ></b-form-input>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <!-- item field -->
                          <b-row class="pb-2 mx-1 mt-3" v-if="menu_id!=15">
                            <b-col sm="5" class="px-1" style="padding-top: 7px !important;">
                              <!-- show Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="line_item"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.item.show"
                                  :disabled="item_prop.label.desc.show==0"
                                />
                                <label for="line_item" style="padding-top:2px;">Product</label>
                              </div>
                            </b-col>
                            <!-- Width and Label values -->
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-1">
                                  <b-form-input
                                    name="item_width"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_width')}"
                                    v-validate="'max_value:100'"
                                    :disabled="item_prop.label.item.show==0"
                                    v-model="item_prop.label.item.width"
                                  ></b-form-input>
                                </b-col>
                                <b-col sm="8" class="px-1">
                                  <b-form-input
                                    name="item_label"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_label')}"
                                    v-validate="'max:50'"
                                    :disabled="item_prop.label.item.show==0"
                                    v-model="item_prop.label.item.label"
                                  ></b-form-input>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <b-row class="pb-2 mx-1 mt-3">
                            <b-col sm="5" class="px-1" style="padding-top: 7px !important;">
                              <!-- show Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="item_desc"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.desc.show"
                                  :disabled="menu_id==15||item_prop.label.item.show==0"
                                />
                                <label for="item_desc" style="padding-top:2px;">Description</label>
                              </div>
                            </b-col>
                            <!-- Width and Label values -->
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-1">
                                  <b-form-input
                                    v-if="item_prop.label.item.show==0||menu_id==15"
                                    name="desc_width"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.desc_width')}"
                                    v-validate="'max_value:100'"
                                    :disabled="item_prop.label.desc.show==0"
                                    v-model="item_prop.label.desc.width"
                                  ></b-form-input>
                                </b-col>
                                <b-col sm="8" class="px-1">
                                  <b-form-input
                                    name="item_desc_label"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_desc_label')}"
                                    v-validate="'max:50'"
                                    :disabled="item_prop.label.desc.show==0"
                                    v-model="item_prop.label.desc.label"
                                  ></b-form-input>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <!-- Quantity field -->
                          <b-row class="pb-2 mx-1 mt-3" v-if="menu_id!=15">
                            <b-col sm="5" class="px-1" style="padding-top: 7px !important;">
                              <!-- show Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="item_qty"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.qty.show"
                                />
                                <label
                                  for="item_qty"
                                  style="padding-top:2px;"
                                >{{ menu_id == 5 || menu_id ==10? 'UPC' : 'Quantity'}}</label>
                              </div>
                            </b-col>
                            <!-- Width and Label values -->
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-1">
                                  <b-form-input
                                    name="item_qty_width"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_qty_width')}"
                                    v-validate="'max_value:100'"
                                    :disabled="item_prop.label.qty.show==0"
                                    v-model="item_prop.label.qty.width"
                                  ></b-form-input>
                                </b-col>
                                <b-col sm="8" class="px-1">
                                  <b-form-input
                                    name="item_qty_label"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_qty_label')}"
                                    v-validate="'max:50'"
                                    :disabled="item_prop.label.qty.show==0"
                                    v-model="item_prop.label.qty.label"
                                  ></b-form-input>
                                  <!-- Show unit -->
                                  <small>
                                    <div class="abc-checkbox pt-2">
                                      <input
                                        type="checkbox"
                                        plain
                                        id="item_unit"
                                        :true-value="1"
                                        :false-value="0"
                                        v-model="item_prop.label.qty.show_unit"
                                        :disabled="item_prop.label.qty.show==0"
                                      />
                                      <label for="item_unit" style="padding-top:2px;">Show Unit</label>
                                    </div>
                                    <!-- <b-form-checkbox
                                  plain
                                  class="pt-1 pb-2"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.qty.show_unit"
                                    >Show Unit</b-form-checkbox>-->
                                  </small>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <b-row class="pb-2 mx-1 mt-3" v-if="menu_id!=15">
                            <b-col sm="5" class="px-1" style="padding-top: 7px !important;">
                              <!-- show Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="item_hsn_label"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.hsn.show"
                                />
                                <label for="item_hsn_label" style="padding-top:2px;">HSN/SAC Label</label>
                              </div>
                            </b-col>
                            <!-- Width and Label values -->
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-1">
                                  <b-form-input
                                    name="item_hsn_width"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_hsn_width')}"
                                    v-validate="'max_value:100'"
                                    :disabled="item_prop.label.hsn.show==0"
                                    v-model="item_prop.label.hsn.width"
                                  ></b-form-input>
                                </b-col>
                                <b-col sm="8" class="px-1">
                                  <b-form-input
                                    name="item_hsn_label"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_hsn_label')}"
                                    v-validate="'max:50'"
                                    :disabled="item_prop.label.hsn.show==0"
                                    v-model="item_prop.label.hsn.label"
                                  ></b-form-input>
                                  <!-- Show unit -->
                                  <small>
                                    <div class="abc-checkbox pt-2">
                                      <input
                                        type="checkbox"
                                        plain
                                        id="item_hsn"
                                        :true-value="1"
                                        :false-value="0"
                                        v-model="item_prop.label.hsn.show_in_desc"
                                        :disabled="item_prop.label.hsn.show==0"
                                      />
                                      <label
                                        for="item_hsn"
                                        style="padding-top:2px;"
                                      >Show Below Description</label>
                                    </div>
                                    <!-- <b-form-checkbox
                                  plain
                                  class="pt-1 pb-2"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.qty.show_unit"
                                    >Show Unit</b-form-checkbox>-->
                                  </small>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>

                          <!-- Rate field -->
                          <b-row class="pb-2 mx-1 mt-3" v-if="menu_id!=15">
                            <b-col sm="5" class="px-1" style="padding-top: 7px !important;">
                              <!-- show Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="item_rate"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.rate.show"
                                />
                                <label
                                  for="item_rate"
                                  style="padding-top:2px;"
                                >{{ menu_id == 5 || menu_id ==10 ? 'MPN' : 'Rate'}}</label>
                              </div>
                            </b-col>
                            <!-- Width and Label values -->
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-1">
                                  <b-form-input
                                    name="rate_width"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.rate_width')}"
                                    v-validate="'max_value:100'"
                                    :disabled="item_prop.label.rate.show==0"
                                    v-model="item_prop.label.rate.width"
                                  ></b-form-input>
                                </b-col>
                                <b-col sm="8" class="px-1">
                                  <b-form-input
                                    name="rate_label"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.rate_label')}"
                                    v-validate="'max:50'"
                                    :disabled="item_prop.label.rate.show==0"
                                    v-model="item_prop.label.rate.label"
                                  ></b-form-input>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <!-- Discount field -->
                          <b-row class="pb-2 mx-1 mt-3" v-if="menu_id!=15">
                            <b-col sm="5" class="px-1" style="padding-top: 7px !important;">
                              <!-- show Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="item_discount"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.discount.show"
                                />
                                <label
                                  for="item_discount"
                                  style="padding-top:2px;"
                                >{{ menu_id == 5 || menu_id ==10 ? 'EAN' : 'Discount'}}</label>
                              </div>
                            </b-col>
                            <!-- Width and Label values -->
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-1">
                                  <b-form-input
                                    name="discount_width"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.discount_width')}"
                                    v-validate="'max_value:100'"
                                    :disabled="item_prop.label.discount.show==0"
                                    v-model="item_prop.label.discount.width"
                                  ></b-form-input>
                                </b-col>
                                <b-col sm="8" class="px-1">
                                  <b-form-input
                                    name="discount_label"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.discount_label')}"
                                    v-validate="'max:50'"
                                    :disabled="item_prop.label.discount.show==0"
                                    v-model="item_prop.label.discount.label"
                                  ></b-form-input>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <!-- Tax field -->
                          <b-row class="pb-2 mx-1 mt-3"  v-if="menu_id!=15">
                            <b-col sm="5" class="px-1" style="padding-top: 7px !important;">
                              <!-- show Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="item_tax"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.tax.show"
                                />
                                <label
                                  for="item_tax"
                                  style="padding-top:2px;"
                                >{{ menu_id == 5 || menu_id ==10? 'ISBN' : 'Tax'}}</label>
                              </div>
                            </b-col>
                            <!-- Width and Label values -->
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-1">
                                  <b-form-input
                                    v-if="(item_prop.label.hasOwnProperty('tax_amt')&&item_prop.label.tax_amt.show)||!item_prop.label.hasOwnProperty('tax_amt')&&menu_id!=15"
                                    name="item_tax_width"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_tax_width')}"
                                    v-validate="'max_value:100'"
                                    :disabled="item_prop.label.tax.show==0"
                                    v-model="item_prop.label.tax.width"
                                  ></b-form-input>
                                </b-col>
                                <b-col sm="8" class="px-1">
                                  <b-form-input
                                    name="item_tax_label"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_tax_label')}"
                                    v-validate="'max:50'"
                                    :disabled="item_prop.label.tax.show==0"
                                    v-model="item_prop.label.tax.label"
                                  ></b-form-input>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <b-row
                            class="pb-2 mx-1 mt-3"
                            v-if="item_prop.label.hasOwnProperty('tax_amt')"
                          >
                            <b-col sm="5" class="px-1" style="padding-top: 7px !important;">
                              <!-- show Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="item_tax_amt"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.tax_amt.show"
                                />
                                <label for="item_tax_amt" style="padding-top:2px;">Tax Amount</label>
                              </div>
                            </b-col>
                            <!-- Width and Label values -->
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-1">
                                  <b-form-input
                                    name="item_tax_amt_width"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_tax_amt_width')}"
                                    v-validate="'max_value:100'"
                                    :disabled="item_prop.label.tax_amt.show==0"
                                    v-model="item_prop.label.tax_amt.width"
                                  ></b-form-input>
                                </b-col>
                                <b-col sm="8" class="px-1">
                                  <b-form-input
                                    name="item_tax_amt_label"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_tax_amt_label')}"
                                    v-validate="'max:50'"
                                    :disabled="item_prop.label.tax_amt.show==0"
                                    v-model="item_prop.label.tax_amt.label"
                                  ></b-form-input>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <!-- Amount field -->
                          <b-row class="pb-2 mx-1 mt-3">
                            <b-col sm="5" class="px-1" style="padding-top: 7px !important;">
                              <!-- show Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="item_amt"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.amt.show"
                                />
                                <label
                                  for="item_amt"
                                  style="padding-top:2px;"
                                >{{ menu_id == 5 || menu_id ==10 ? 'Qty' : 'Amount'}}</label>
                              </div>
                            </b-col>
                            <!-- Width and Label values -->
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-1">
                                  <b-form-input
                                    name="item_amt_width"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_amt_width')}"
                                    v-validate="'max_value:100'"
                                    :disabled="item_prop.label.amt.show==0"
                                    v-model="item_prop.label.amt.width"
                                  ></b-form-input>
                                </b-col>
                                <b-col sm="8" class="px-1">
                                  <b-form-input
                                    name="item_amt_label"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_amt_label')}"
                                    v-validate="'max:50'"
                                    :disabled="item_prop.label.amt.show==0"
                                    v-model="item_prop.label.amt.label"
                                  ></b-form-input>
                                  <!-- <small>
                                    <div class="abc-checkbox pt-2">
                                      <input
                                        type="checkbox"
                                        plain
                                        id="item_amt_tax"
                                        :true-value="1"
                                        :false-value="0"
                                        v-model="item_prop.label.amt.add_tax_amt"
                                        :disabled="item_prop.label.amt.show==0"
                                      />
                                      <label for="item_amt_tax" style="padding-top:2px;">Add tax to amount</label>
                                    </div>
                                  </small>-->
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <!-- Custom field -->
                          <b-row
                            class="pb-2 mx-1 mt-3"
                            v-if="item_prop.label.hasOwnProperty('custom_field')"
                          >
                            <b-col sm="5" class="px-1" style="padding-top: 7px !important;">
                              <!-- show Custom Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="item_cf"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.custom_field.show"
                                  disabled
                                />
                                <label
                                  for="item_cf"
                                  style="padding-top:2px;"
                                  v-b-tooltip.top="'The width entered shall be applicable for all the custom fields created with Show in all PDF option'"
                                >Custom Field</label>
                              </div>
                            </b-col>
                            <!-- Width and Label values -->
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-1">
                                  <b-form-input
                                    name="item_cf_width"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_cf_width')}"
                                    v-validate="'max_value:100'"
                                    :disabled="item_prop.label.custom_field.show==0"
                                    v-model="item_prop.label.custom_field.width"
                                  ></b-form-input>
                                </b-col>
                                <b-col sm="8" class="px-1">
                                  <b-form-input
                                    name="item_cf_label"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_cf_label')}"
                                    v-validate="'max:50'"
                                    disabled
                                    v-model="item_prop.label.custom_field.label"
                                  ></b-form-input>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <template v-if="menu_id == 9">
                            <b-row class="mt-3 ml-0">
                              <b-col class="px-0">
                                <h6 class="mb-3 h6-lg text-link">Bill Details</h6>
                              </b-col>
                            </b-row>
                            <b-row class="mx-1 mt-2">
                              <b-col sm="12" class="px-1">
                                <!-- Show Bill Details Section -->
                                <b-form-group>
                                  <div class="abc-checkbox">
                                    <input
                                      type="checkbox"
                                      id="show_bill_details"
                                      :true-value="1"
                                      :false-value="0"
                                      v-model="item_prop.label.show_bill_details"
                                    />
                                    <label
                                      for="show_bill_details"
                                      style="padding-top:2px;"
                                    >Show details of Bills applied to Credit Note</label>
                                  </div>
                                </b-form-group>
                                <div v-if="item_prop.label.show_bill_details==1">
                                  <!--Appiled to -->
                                  <b-form-group
                                    class="mb-4"
                                    horizontal
                                    label="Applied to"
                                    label-for="applied_to"
                                    :label-cols="5"
                                  >
                                    <b-form-input
                                      name="applied_to"
                                      :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.applied_to')}"
                                      v-validate="'max:50'"
                                      v-model="item_prop.label.applied_to"
                                    ></b-form-input>
                                  </b-form-group>
                                  <!-- Display Only Bill section show -->

                                  <b-row class="my-3">
                                    <b-col sm="5" style="padding-top: 7px !important;">
                                      <!-- Show Bill no-->
                                      <div class="abc-checkbox">
                                        <input
                                          type="checkbox"
                                          id="bill_no"
                                          :true-value="1"
                                          :false-value="0"
                                          v-model="item_prop.label.bill_no.show"
                                        />
                                        <label for="bill_no" style="padding-top:2px;">Bill#</label>
                                      </div>
                                    </b-col>
                                    <b-col class="pl-2" sm="7">
                                      <!-- bill no Lable -->
                                      <b-form-input
                                        name="bill_no_label"
                                        :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.bill_no_label')}"
                                        v-validate="'max:50'"
                                        :disabled="item_prop.label.bill_no.show==0"
                                        v-model="item_prop.label.bill_no.label"
                                      ></b-form-input>
                                    </b-col>
                                  </b-row>
                                  <b-row class="my-3">
                                    <b-col sm="5" style="padding-top: 7px !important;">
                                      <!-- Show Bill date-->
                                      <div class="abc-checkbox">
                                        <input
                                          type="checkbox"
                                          id="bill_date"
                                          :true-value="1"
                                          :false-value="0"
                                          v-model="item_prop.label.bill_date.show"
                                        />
                                        <label for="sub_total" style="padding-top:2px;">Bill Date</label>
                                      </div>
                                    </b-col>
                                    <b-col class="pl-2" sm="7">
                                      <!-- bill date Lable -->
                                      <b-form-input
                                        name="bill_date_label"
                                        :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.bill_date_label')}"
                                        v-validate="'max:50'"
                                        :disabled="item_prop.label.bill_date.show==0"
                                        v-model="item_prop.label.bill_date.label"
                                      ></b-form-input>
                                    </b-col>
                                  </b-row>
                                  <b-row class="my-3">
                                    <b-col sm="5" style="padding-top: 7px !important;">
                                      <!-- Show Bill amount-->
                                      <div class="abc-checkbox">
                                        <input
                                          type="checkbox"
                                          id="bill_amount"
                                          :true-value="1"
                                          :false-value="0"
                                          v-model="item_prop.label.bill_amount.show"
                                        />
                                        <label for="sub_total" style="padding-top:2px;">Bill Amount</label>
                                      </div>
                                    </b-col>
                                    <b-col class="pl-2" sm="7">
                                      <!-- bill amount Lable -->
                                      <b-form-input
                                        name="bill_amount_label"
                                        :class="{'is-invalid':item_label_has_error&&errors.has('item_prop.bill_amount_label')}"
                                        v-validate="'max:50'"
                                        :disabled="item_prop.label.bill_amount.show==0"
                                        v-model="item_prop.label.bill_amount.label"
                                      ></b-form-input>
                                    </b-col>
                                  </b-row>
                                  <b-row class="my-3">
                                    <b-col sm="5" style="padding-top: 7px !important;">
                                      <!-- Show payment amount-->
                                      <div class="abc-checkbox">
                                        <input
                                          type="checkbox"
                                          id="payment_amount"
                                          :true-value="1"
                                          :false-value="0"
                                          v-model="item_prop.label.payment_amount.show"
                                        />
                                        <label
                                          for="sub_total"
                                          style="padding-top:2px;"
                                        >Payment Amount</label>
                                      </div>
                                    </b-col>
                                    <b-col class="pl-2" sm="7">
                                      <!-- payment amount Lable -->
                                      <b-form-input
                                        name="payment_amount_label"
                                        :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.payment_amount_label')}"
                                        v-validate="'max:50'"
                                        :disabled="item_prop.label.payment_amount.show==0"
                                        v-model="item_prop.label.payment_amount.label"
                                      ></b-form-input>
                                    </b-col>
                                  </b-row>
                                </div>
                              </b-col>
                            </b-row>
                          </template>
                        </b-form>
                      </b-tab>
                      <!-- Layout Tab -->
                      <b-tab title="Layout">
                        <!-- Table Border -->
                        <b-form data-vv-scope="item_layout_prop_tab">
                          <b-row class="mb-2 mt-4 ml-0">
                            <b-col class="px-0">
                              <!-- Table border color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Table Border"
                                label-for="tbl_border"
                                :label-cols="5"
                              >
                                <b-input-group class="colorpicker-wrapper">
                                  <!-- Show Field -->
                                  <div class="abc-checkbox" style="padding-top:5px;">
                                    <input
                                      type="checkbox"
                                      id="tbl_border_color"
                                      :true-value="1"
                                      :false-value="0"
                                      v-model="item_prop.layout.table_border.show"
                                    />
                                    <label for="tbl_border_color"></label>
                                  </div>
                                  <!-- Color Picker -->
                                  <input
                                    type="text"
                                    class="form-control"
                                    disabled
                                    :value="item_prop.layout.table_border.value.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_5 }"
                                    v-model="item_prop.layout.table_border.value"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_5  = !colorPickerActive.color_5 "
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': item_prop.layout.table_border.value.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                          <!-- Table Header Fields -->
                          <b-row class="my-2 ml-0">
                            <b-col class="px-0">
                              <h6 class="mb-3 h6-lg text-link">Table Header</h6>
                              <!-- Table Header Font Size -->
                              <b-form-group
                                class="mb-4"
                                label="Font Size"
                                horizontal
                                label-for="tbl_hdr_size"
                                :label-cols="5"
                              >
                                <b-input-group append="pt">
                                  <b-form-input
                                    name="tbl_hdr_size"
                                    :class="{'is-invalid':item_layout_has_error&&errors.has('item_layout_prop_tab.tbl_hdr_size')}"
                                    v-validate="'min_value:0|max_value:18'"
                                    v-model="item_prop.layout.header_font_size"
                                  ></b-form-input>
                                </b-input-group>
                              </b-form-group>
                              <!-- Table Header Background color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Background Color"
                                label-for="tbl_hdr_bg"
                                :label-cols="5"
                              >
                                <b-input-group class="colorpicker-wrapper">
                                  <!-- Show Field -->
                                  <div class="abc-checkbox" style="padding-top:5px;">
                                    <input
                                      type="checkbox"
                                      id="tbl_hdr_bg_color"
                                      :true-value="1"
                                      :false-value="0"
                                      v-model="item_prop.layout.bg_color.show"
                                    />
                                    <label for="tbl_hdr_bg_color"></label>
                                  </div>
                                  <!-- Color Picker -->
                                  <input
                                    type="text"
                                    class="form-control"
                                    disabled
                                    :value="item_prop.layout.bg_color.value.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_6 }"
                                    v-model="item_prop.layout.bg_color.value"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_6 = !colorPickerActive.color_6"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': item_prop.layout.bg_color.value.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                              <!-- Table Header font Color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Font Color"
                                label-for="tbl_hdr_font_color"
                                :label-cols="5"
                              >
                                <!-- Color Picker -->
                                <b-input-group class="colorpicker-wrapper">
                                  <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    :value="item_prop.layout.header_font_color.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_7 }"
                                    v-model="item_prop.layout.header_font_color"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_7 = !colorPickerActive.color_7"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': item_prop.layout.header_font_color.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                          <!-- Product Row Fields -->
                          <b-row
                            class="my-2 ml-0"
                            v-if="item_prop.layout.hasOwnProperty('item_row_font_size')"
                          >
                            <b-col class="px-0">
                              <h6 class="mb-3 h6-lg text-link">Product Row</h6>
                              <!--Product Row Font Size -->
                              <b-form-group
                                class="mb-4"
                                label="Font Size"
                                horizontal
                                label-for="pdt_row_size"
                                :label-cols="5"
                              >
                                <b-input-group append="pt">
                                  <b-form-input
                                    name="pdt_row_size"
                                    :class="{'is-invalid':item_layout_has_error&&errors.has('item_layout_prop_tab.pdt_row_size')}"
                                    v-validate="'min_value:0|max_value:18'"
                                    v-model="item_prop.layout.item_row_font_size"
                                  ></b-form-input>
                                </b-input-group>
                              </b-form-group>
                              <!-- Product Row Background color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Background Color"
                                label-for="item_row_bg_color"
                                :label-cols="5"
                              >
                                <b-input-group class="colorpicker-wrapper">
                                  <!-- Show Field -->
                                  <div class="abc-checkbox" style="padding-top:5px;">
                                    <input
                                      type="checkbox"
                                      id="item_row_bg_color"
                                      :true-value="1"
                                      :false-value="0"
                                      v-model="item_prop.layout.item_row_bg_color.show"
                                    />
                                    <label for="item_row_bg_color"></label>
                                  </div>
                                  <!-- Color Picker -->
                                  <input
                                    type="text"
                                    class="form-control"
                                    disabled
                                    :value="item_prop.layout.item_row_bg_color.value.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_14 }"
                                    v-model="item_prop.layout.item_row_bg_color.value"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_14 = !colorPickerActive.color_14"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': item_prop.layout.item_row_bg_color.value.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                              <!-- Product Row font Color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Font Color"
                                label-for="item_row_font_color"
                                :label-cols="5"
                              >
                                <!-- Color Picker -->
                                <b-input-group class="colorpicker-wrapper">
                                  <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    :value="item_prop.layout.item_row_font_color.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_15 }"
                                    v-model="item_prop.layout.item_row_font_color"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_15 = !colorPickerActive.color_15"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': item_prop.layout.item_row_font_color.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                          <!-- Item Description Fields -->

                          <b-row
                            class="my-2 ml-0"
                            :style="{'margin-bottom':colorPickerActive.color_8?'310px':colorPickerActive.color_7?'100px':colorPickerActive.color_6?'50px':'unset'}"
                          >
                            <b-col class="px-0">
                              <h6 class="mb-3 h6-lg text-link">Product Description</h6>
                              <!-- Item Description Font Size -->
                              <b-form-group
                                class="mb-4"
                                label="Font Size"
                                horizontal
                                label-for="itm_desc_font_size"
                                :label-cols="5"
                              >
                                <b-input-group append="pt">
                                  <b-form-input
                                    name="itm_desc_font_size"
                                    :class="{'is-invalid':item_layout_has_error&&errors.has('item_layout_prop_tab.itm_desc_font_size')}"
                                    v-validate="'min_value:0|max_value:18'"
                                    v-model="item_prop.layout.item_font_size"
                                  ></b-form-input>
                                </b-input-group>
                              </b-form-group>
                              <!-- Item Description Font Color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Font Color"
                                label-for="desc_bg_color"
                                :label-cols="5"
                              >
                                <!-- Color Picker -->
                                <b-input-group class="colorpicker-wrapper">
                                  <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    :value="item_prop.layout.item_font_color.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_8 }"
                                    v-model="item_prop.layout.item_font_color"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_8  = !colorPickerActive.color_8 "
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': item_prop.layout.item_font_color.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-form>
                      </b-tab>
                    </b-tabs>
                  </b-row>
                </b-tab>
                <!-- Item Properties -->
                <b-tab title="Receipt" class="px-pad py-3 mt-2 mr-4" v-if="receipt_info&&menu_id!=15">
                  <b-form data-vv-scope="receipt_prop_tab">
                    <b-row class="ml-1">
                      <b-col class="px-0">
                        <b-row class="my-2 ml-0">
                            <b-col class="px-0">
                              <h6 class="mb-3 h6-lg text-link">Document Information</h6>
                               <b-row class="pb-2" v-if="receipt_info.hasOwnProperty('doc_title')">
                                  <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                                    <div class="abc-checkbox">
                                      <input
                                        type="checkbox"
                                        id="doc_title"
                                        :true-value="1"
                                        :false-value="0"
                                        v-model="receipt_info.doc_title.show"
                                      />
                                      <label for="doc_title" style="padding-top:2px;">Document Title</label>
                                    </div>
                                  </b-col>
                                  <b-col sm="7" style="padding-left: 7px !important">
                                    <b-form-input
                                      name="doc_title_label"
                                      :class="{'is-invalid':receipt_has_error&&errors.has('receipt_prop_tab.doc_title_label')}"
                                      v-validate="'max:50'"
                                      :disabled="receipt_info.doc_title.show==0"
                                      v-model="receipt_info.doc_title.label"
                                    ></b-form-input>
                                  </b-col>
                                </b-row>
                                <b-form-group
                                label="Font Size"
                                horizontal
                                label-for="doc_font_size"
                                :label-cols="5"
                                v-if="receipt_info.hasOwnProperty('doc_font_size')">
                                <b-input-group append="pt">
                                  <b-form-input
                                    name="doc_font_size"
                                    :class="{'is-invalid':receipt_has_error&&errors.has('receipt_prop_tab.doc_font_size')}"
                                    v-validate="'min_value:0|max_value:18'"
                                    v-model="receipt_info.doc_font_size"
                                  ></b-form-input>
                                </b-input-group>
                              </b-form-group>
                                <b-form-group
                                class="mb-4"
                                horizontal
                                label="Font Color"
                                label-for="doc_font_color"
                                :label-cols="5"
                                v-if="receipt_info.hasOwnProperty('doc_font_color')"
                              >
                                <!-- Color Picker -->
                                <b-input-group class="colorpicker-wrapper">
                                  <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    :value="receipt_info.doc_font_color.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_20 }"
                                    v-model="receipt_info.doc_font_color"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_20 = !colorPickerActive.color_20"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': receipt_info.doc_font_color.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                        </b-row>
                        <b-form-group>
                          <b-row class="pb-2" v-if="receipt_info.hasOwnProperty('doc_no')">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Number Label -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="doc_no"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="receipt_info.doc_no.show"
                                />
                                <label for="doc_no" style="padding-top:2px;">Number Field</label>
                              </div>
                            </b-col>

                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Number Label -->
                              <b-form-input
                                name="doc_no_label"
                                :class="{'is-invalid':receipt_has_error&&errors.has('receipt_prop_tab.doc_no_label')}"
                                v-validate="'max:50'"
                                :disabled="receipt_info.doc_no.show==0"
                                v-model="receipt_info.doc_no.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <b-row class="pb-2" v-if="receipt_info.hasOwnProperty('doc_pymt_mode')">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Number Label -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="doc_pymt_mode"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="receipt_info.doc_pymt_mode.show"
                                />
                                <label for="doc_pymt_mode" style="padding-top:2px;">Payment Mode</label>
                              </div>
                            </b-col>

                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Number Label -->
                              <b-form-input
                                name="doc_pymt_mode_label"
                                :class="{'is-invalid':receipt_has_error&&errors.has('receipt_prop_tab.doc_pymt_mode_label')}"
                                v-validate="'max:50'"
                                :disabled="receipt_info.doc_pymt_mode.show==0"
                                v-model="receipt_info.doc_pymt_mode.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <b-row class="pb-2" v-if="receipt_info.hasOwnProperty('doc_date')">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Number Label -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="doc_date"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="receipt_info.doc_date.show"
                                />
                                <label for="doc_date" style="padding-top:2px;">Date Field</label>
                              </div>
                            </b-col>

                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Number Label -->
                              <b-form-input
                                name="doc_date_label"
                                :class="{'is-invalid':receipt_has_error&&errors.has('receipt_prop_tab.doc_date_label')}"
                                v-validate="'max:50'"
                                :disabled="receipt_info.doc_date.show==0"
                                v-model="receipt_info.doc_date.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <b-row class="pb-2" v-if="receipt_info.hasOwnProperty('doc_ref_no')">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Number Label -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="doc_ref_no"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="receipt_info.doc_ref_no.show"
                                />
                                <label for="doc_ref_no" style="padding-top:2px;">Reference Field</label>
                              </div>
                            </b-col>

                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Number Label -->
                              <b-form-input
                                name="doc_ref_no_label"
                                :class="{'is-invalid':receipt_has_error&&errors.has('receipt_prop_tab.doc_ref_no_label')}"
                                v-validate="'max:50'"
                                :disabled="receipt_info.doc_ref_no.show==0"
                                v-model="receipt_info.doc_ref_no.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <b-row class="pb-2" v-if="receipt_info.hasOwnProperty('doc_over_pymt')">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Number Label -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="doc_over_pymt"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="receipt_info.doc_over_pymt.show"
                                />
                                <label for="doc_over_pymt" style="padding-top:2px;">Over Payment</label>
                              </div>
                            </b-col>

                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Number Label -->
                              <b-form-input
                                name="doc_over_pymt_label"
                                :class="{'is-invalid':receipt_has_error&&errors.has('receipt_prop_tab.doc_over_pymt_label')}"
                                v-validate="'max:50'"
                                :disabled="receipt_info.doc_over_pymt.show==0"
                                v-model="receipt_info.doc_over_pymt.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <b-row class="pb-2" v-if="receipt_info.hasOwnProperty('doc_pymt_refund')">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Number Label -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="doc_pymt_refund"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="receipt_info.doc_pymt_refund.show"
                                />
                                <label for="doc_pymt_refund" style="padding-top:2px;">Payment Refund</label>
                              </div>
                            </b-col>

                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Number Label -->
                              <b-form-input
                                name="doc_pymt_refund_label"
                                :class="{'is-invalid':receipt_has_error&&errors.has('receipt_prop_tab.doc_pymt_refund_label')}"
                                v-validate="'max:50'"
                                :disabled="receipt_info.doc_pymt_refund.show==0"
                                v-model="receipt_info.doc_pymt_refund.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <!-- Show amount in words -->
                          <b-form-group class="mb-5" v-if="receipt_info.hasOwnProperty('show_amt_wrd')">
                                <div class="abc-checkbox">
                                  <input
                                    type="checkbox"
                                    id="show_amt_in_word"
                                    :true-value="1"
                                    :false-value="0"
                                    v-model="receipt_info.show_amt_wrd"
                                  />
                                  <label
                                    for="show_amt_in_word"
                                    style="padding-top:2px;"
                                  >Show Amount in Words</label>
                                </div>
                          </b-form-group>
                         <b-row class="my-2 ml-0">
                            <b-col class="px-0">
                              <h6 class="mb-3 h6-lg text-link">Customer Name</h6>
                            </b-col>
                          </b-row>
                           <!-- Received From -->
                        <b-form-group class="mt-4">
                          <div class="abc-checkbox">
                            <input
                              type="checkbox"
                              id="cus_recv_from"
                              :true-value="1"
                              :false-value="0"
                              v-model="receipt_info.cus_recv_from.show"
                            />
                            <label for="cus_recv_from" style="padding-top:2px;">Received From</label>
                          </div>
                        </b-form-group>
                        <b-form-group class="mb-4">
                          <b-form-input
                          :disabled="receipt_info.cus_recv_from.show==0"
                            v-model="receipt_info.cus_recv_from.label"
                            name="cus_recv_from_label"
                            v-validate="'max:50'"
                            :class="{'is-invalid':receipt_has_error&&errors.has('receipt_prop_tab.cus_recv_from_label')}"
                          ></b-form-input>
                        </b-form-group>
                          <b-form-group
                            label="Font Size"
                            horizontal
                            label-for="bill_addr_font_size"
                            :label-cols="5"
                            v-if="receipt_info.hasOwnProperty('bill_addr_font_size')">
                              <b-input-group append="pt">
                                  <b-form-input
                                    name="bill_addr_font_size"
                                    :class="{'is-invalid':receipt_has_error&&errors.has('receipt_prop_tab.bill_addr_font_size')}"
                                    v-validate="'min_value:0|max_value:18'"
                                    v-model="receipt_info.bill_addr_font_size"
                                  ></b-form-input>
                              </b-input-group>
                           </b-form-group>
                            <b-form-group
                                class="mb-4"
                                horizontal
                                label="Font Color"
                                label-for="bill_addr_font_color"
                                :label-cols="5"
                                v-if="receipt_info.hasOwnProperty('bill_addr_font_color')"
                              >
                                <!-- Color Picker -->
                                <b-input-group class="colorpicker-wrapper">
                                  <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    :value="receipt_info.bill_addr_font_color.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_21 }"
                                    v-model="receipt_info.bill_addr_font_color"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_21 = !colorPickerActive.color_21"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': receipt_info.bill_addr_font_color.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                              <b-form-group
                          horizontal
                          label="Amount Received"
                          label-for="amt_recv_label"
                          :label-cols="5"
                        >
                          <b-form-input
                            name="amt_recv_label"
                            :class="{'is-invalid':receipt_has_error&&errors.has('receipt_prop_tab.amt_recv_label')}"
                            v-validate="'max:50'"
                            v-model="receipt_info.amt_recv_label"
                          ></b-form-input>
                        </b-form-group>
                              <b-form-group
                                  label="Currency Symbol"
                                  label-cols="6"
                                  label-for="currency_syb"
                                  v-if="receipt_info.currency_syb"
                                >
                                  <b-form-radio-group
                                    :options="[{value:1,text:'Before amount'},{value:2,text:'After amount'}]"
                                    v-model="receipt_info.currency_syb"
                                  ></b-form-radio-group>
                                </b-form-group>
                              <b-row class="my-2 ml-0">
                            <b-col class="px-0">
                              <h6 class="mb-3 h6-lg text-link">Amount Received</h6>
                            </b-col>
                          </b-row>
                           <!--Amount Received -->
                          <b-form-group
                            label="Font Size"
                            horizontal
                            label-for="amt_recv_font_size"
                            :label-cols="5"
                            v-if="receipt_info.hasOwnProperty('amt_recv_font_size')">
                              <b-input-group append="pt">
                                  <b-form-input
                                    name="amt_recv_font_size"
                                    :class="{'is-invalid':receipt_has_error&&errors.has('receipt_prop_tab.amt_recv_font_size')}"
                                    v-validate="'min_value:0|max_value:18'"
                                    v-model="receipt_info.amt_recv_font_size"
                                  ></b-form-input>
                              </b-input-group>
                           </b-form-group>
                            <b-form-group
                                class="mb-4"
                                horizontal
                                label="Font Color"
                                label-for="amt_recv_font_color"
                                :label-cols="5"
                                v-if="receipt_info.hasOwnProperty('amt_recv_font_color')"
                              >
                                <!-- Color Picker -->
                                <b-input-group class="colorpicker-wrapper">
                                  <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    :value="receipt_info.amt_recv_font_color.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_22 }"
                                    v-model="receipt_info.amt_recv_font_color"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_22 = !colorPickerActive.color_22"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': receipt_info.amt_recv_font_color.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                               <b-form-group
                          class="pb-1 mb-4"
                          label="Background Color"
                          label-for="amt_recv_bg_color"
                          :label-cols="5"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <div class="abc-checkbox" style="padding-top:5px;">
                              <input
                                type="checkbox"
                                id="amt_recv_bg_color"
                                :true-value="1"
                                :false-value="0"
                                v-model="receipt_info.amt_recv_bg_color.show"
                              />
                              <label for="amt_recv_bg_color"></label>
                            </div>
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              :value="receipt_info.amt_recv_bg_color.value.hex"
                            />

                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_23 }"
                              v-model="receipt_info.amt_recv_bg_color.value"
                            />

                            <b-input-group-text
                              @click="colorPickerActive.color_23=!colorPickerActive.color_23"
                              slot="append"
                              style="padding:5px !important;"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': receipt_info.amt_recv_bg_color.value.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>
                         <b-row class="my-2 ml-0" v-if="receipt_info.hasOwnProperty('signature')">
                        <b-col class="px-0" style="padding-top: 7px !important;">
                          <h6 class="mb-3 h6-lg text-link">Signature</h6>
                          <!-- Show Signature Details -->
                          <b-row class="my-2 ml-0">
                            <b-col class="px-0" style="padding-top: 7px !important;">
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="show_sign"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="receipt_info.signature.show"
                                />
                                <label for="show_sign" style="padding-top:2px;">Show Signature</label>
                              </div>
                            </b-col>
                          </b-row>
                          <!-- Signature Label -->
                          <b-form-group
                            class="mb-4"
                            horizontal
                            label="Label"
                            label-for="sign_label"
                            :label-cols="5"
                          >
                            <b-form-input
                              name="sign_label"
                              :class="{'is-invalid':receipt_has_error&&errors.has('receipt_prop_tab.sign_label')}"
                              v-validate="'max:50'"
                              v-model="receipt_info.signature.label"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row class="my-2 ml-0" v-if="receipt_info.hasOwnProperty('add_signature')">
                        <b-col class="px-0" style="padding-top: 7px !important;">
                          <h6 class="mb-3 h6-lg text-link">Additional Signature</h6>
                          <!-- Show Signature Details -->
                          <b-row class="my-2 ml-0">
                            <b-col class="px-0" style="padding-top: 7px !important;">
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="show_add_sign"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="receipt_info.add_signature.show"
                                />
                                <label for="show_add_sign" style="padding-top:2px;">Show Additional Signature</label>
                              </div>
                            </b-col>
                          </b-row>
                          <!-- Signature Label -->
                          <b-form-group
                            class="mb-4"
                            horizontal
                            label="Label"
                            label-for="add_sign_label"
                            :label-cols="5"
                          >
                            <b-form-input
                              name="add_sign_label"
                              :class="{'is-invalid':footer_has_error&&errors.has('receipt_prop_tab.add_sign_label')}"
                              v-validate="'max:50'"
                              v-model="receipt_info.add_signature.label"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-tab>
                <b-tab title="Invoice" class="px-pad py-3 mt-2 mr-4" v-if="inv_details&&menu_id!=15">
                  <b-tabs
                      v-model="invTabIndex"
                      class="nav-cols custom-line-tab button-nav button-tab"
                    >
                      <!-- Label Tab -->
                      <b-tab title="Labels" class="px-0" active>
                        <b-form data-vv-scope="inv_label_prop_tab">
                        <b-form-group class="mt-5">
                                <div class="abc-checkbox">
                                  <input
                                    type="checkbox"
                                    id="show_amt_word"
                                    :true-value="1"
                                    :false-value="0"
                                    v-model="inv_details.label.show_inv_detail"
                                  />
                                  <label
                                    for="show_amt_word"
                                    style="padding-top:2px;"
                                  >Show Invoice Details</label>
                                </div>
                              </b-form-group>
                              <b-form-group
                          horizontal
                          label="Payment for"
                          label-for="pymt_for_label"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-form-input
                            name="pymt_for_label"
                            :class="{'is-invalid':inv_label_has_error&&errors.has('inv_label_prop_tab.pymt_for_label')}"
                            v-validate="'max:50'"
                            v-model="inv_details.label.pymt_for_label"
                            :disabled="inv_details.label.show_inv_detail==0"
                          ></b-form-input>
                        </b-form-group>

                         <b-row class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Date Label -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="inv_no"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="inv_details.label.inv_no.show"
                                />
                                <label for="inv_no" style="padding-top:2px;">Invoice#</label>
                              </div>
                            </b-col>

                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Date Label -->
                              <b-form-input
                                name="inv_no_label"
                                :class="{'is-invalid':inv_label_has_error&&errors.has('inv_label_prop_tab.inv_no_label')}"
                                v-validate="'max:50'"
                                :disabled="inv_details.label.inv_no.show==0||inv_details.label.show_inv_detail==0"
                                v-model="inv_details.label.inv_no.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                         <b-row class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Date Label -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="inv_date"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="inv_details.label.inv_date.show"
                                />
                                <label for="inv_date" style="padding-top:2px;">Invoice Date</label>
                              </div>
                            </b-col>

                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Date Label -->
                              <b-form-input
                                name="inv_date_label"
                                :class="{'is-invalid':inv_label_has_error&&errors.has('inv_label_prop_tab.inv_date_label')}"
                                v-validate="'max:50'"
                                :disabled="inv_details.label.inv_date.show==0||inv_details.label.show_inv_detail==0"
                                v-model="inv_details.label.inv_date.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                         <b-row class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Date Label -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="inv_amt"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="inv_details.label.inv_amt.show"
                                />
                                <label for="inv_amt" style="padding-top:2px;">Invoice Amount</label>
                              </div>
                            </b-col>

                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Date Label -->
                              <b-form-input
                                name="inv_amt_label"
                                :class="{'is-invalid':inv_label_has_error&&errors.has('inv_label_prop_tab.inv_amt_label')}"
                                v-validate="'max:50'"
                                :disabled="inv_details.label.inv_amt.show==0||inv_details.label.show_inv_detail==0"
                                v-model="inv_details.label.inv_amt.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                         <b-row class="pb-2" v-if="inv_details.label.hasOwnProperty('withholding_tax')">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Date Label -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="withholding_tax"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="inv_details.label.withholding_tax.show"
                                />
                                <label for="withholding_tax" style="padding-top:2px;">Withholding Tax</label>
                              </div>
                            </b-col>

                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Date Label -->
                              <b-form-input
                                name="withholding_tax_label"
                                :class="{'is-invalid':inv_label_has_error&&errors.has('inv_label_prop_tab.withholding_tax_label')}"
                                v-validate="'max:50'"
                                :disabled="inv_details.label.withholding_tax.show==0||inv_details.label.show_inv_detail==0"
                                v-model="inv_details.label.withholding_tax.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                         <b-row class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Date Label -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="pymt_amt"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="inv_details.label.pymt_amt.show"
                                />
                                <label for="pymt_amt" style="padding-top:2px;">Payment Amount</label>
                              </div>
                            </b-col>

                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Date Label -->
                              <b-form-input
                                name="pymt_amt_label"
                                :class="{'is-invalid':inv_label_has_error&&errors.has('inv_label_prop_tab.pymt_amt_label')}"
                                v-validate="'max:50'"
                                :disabled="inv_details.label.pymt_amt.show==0||inv_details.label.show_inv_detail==0"
                                v-model="inv_details.label.pymt_amt.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                        </b-form>
                      </b-tab>
                      <b-tab title="Layout">
                        <b-form data-vv-scope="inv_layout_prop_tab">
                          <b-row class="mb-2 mt-4 ml-0">
                            <b-col class="px-0">
                              <!-- Table border color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Table Border"
                                label-for="tbl_border"
                                :label-cols="5"
                              >
                                <b-input-group class="colorpicker-wrapper">
                                  <!-- Show Field -->
                                  <div class="abc-checkbox" style="padding-top:5px;">
                                    <input
                                      type="checkbox"
                                      id="tbl_border_color"
                                      :true-value="1"
                                      :false-value="0"
                                      v-model="inv_details.layout.table_border.show"
                                    />
                                    <label for="tbl_border_color"></label>
                                  </div>
                                  <!-- Color Picker -->
                                  <input
                                    type="text"
                                    class="form-control"
                                    disabled
                                    :value="inv_details.layout.table_border.value.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_24 }"
                                    v-model="inv_details.layout.table_border.value"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_24  = !colorPickerActive.color_24 "
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': inv_details.layout.table_border.value.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                           <!-- Table Header Fields -->
                          <b-row class="my-2 ml-0">
                            <b-col class="px-0">
                              <h6 class="mb-3 h6-lg text-link">Table Header</h6>
                              <!-- Table Header Font Size -->
                              <b-form-group
                                class="mb-4"
                                label="Font Size"
                                horizontal
                                label-for="tbl_hdr_size"
                                :label-cols="5"
                              >
                                <b-input-group append="pt">
                                  <b-form-input
                                    name="tbl_hdr_size"
                                    :class="{'is-invalid':inv_layout_has_error&&errors.has('inv_layout_prop_tab.tbl_hdr_size')}"
                                    v-validate="'min_value:0|max_value:18'"
                                    v-model="inv_details.layout.header_font_size"
                                  ></b-form-input>
                                </b-input-group>
                              </b-form-group>
                              <!-- Table Header Background color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Background Color"
                                label-for="tbl_hdr_bg"
                                :label-cols="5"
                              >
                                <b-input-group class="colorpicker-wrapper">
                                  <!-- Show Field -->
                                  <div class="abc-checkbox" style="padding-top:5px;">
                                    <input
                                      type="checkbox"
                                      id="tbl_hdr_bg_color"
                                      :true-value="1"
                                      :false-value="0"
                                      v-model="inv_details.layout.header_bg_color.show"
                                    />
                                    <label for="tbl_hdr_bg_color"></label>
                                  </div>
                                  <!-- Color Picker -->
                                  <input
                                    type="text"
                                    class="form-control"
                                    disabled
                                    :value="inv_details.layout.header_bg_color.value.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_25 }"
                                    v-model="inv_details.layout.header_bg_color.value"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_25 = !colorPickerActive.color_25"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': inv_details.layout.header_bg_color.value.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                              <!-- Table Header font Color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Font Color"
                                label-for="tbl_hdr_font_color"
                                :label-cols="5"
                              >
                                <!-- Color Picker -->
                                <b-input-group class="colorpicker-wrapper">
                                  <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    :value="inv_details.layout.header_font_color.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_26 }"
                                    v-model="inv_details.layout.header_font_color"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_26 = !colorPickerActive.color_26"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': inv_details.layout.header_font_color.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                          <!-- Product Row Fields -->
                          <b-row class="my-2 ml-0" v-if="inv_details.layout.hasOwnProperty('item_row_font_size')">
                            <b-col class="px-0">
                              <h6 class="mb-3 h6-lg text-link">Product Row</h6>
                              <!--Product Row Font Size -->
                              <b-form-group
                                class="mb-4"
                                label="Font Size"
                                horizontal
                                label-for="pdt_row_size"
                                :label-cols="5"
                              >
                                <b-input-group append="pt">
                                  <b-form-input
                                    name="pdt_row_size"
                                    :class="{'is-invalid':inv_layout_has_error&&errors.has('inv_layout_prop_tab.pdt_row_size')}"
                                    v-validate="'min_value:0|max_value:18'"
                                    v-model="inv_details.layout.item_row_font_size"
                                  ></b-form-input>
                                </b-input-group>
                              </b-form-group>
                              <!-- Product Row Background color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Background Color"
                                label-for="item_row_bg_color"
                                :label-cols="5"
                              >
                                <b-input-group class="colorpicker-wrapper">
                                  <!-- Show Field -->
                                  <div class="abc-checkbox" style="padding-top:5px;">
                                    <input
                                      type="checkbox"
                                      id="item_row_bg_color"
                                      :true-value="1"
                                      :false-value="0"
                                      v-model="inv_details.layout.item_row_bg_color.show"
                                    />
                                    <label for="item_row_bg_color"></label>
                                  </div>
                                  <!-- Color Picker -->
                                  <input
                                    type="text"
                                    class="form-control"
                                    disabled
                                    :value="inv_details.layout.item_row_bg_color.value.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_27 }"
                                    v-model="inv_details.layout.item_row_bg_color.value"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_27 = !colorPickerActive.color_27"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': inv_details.layout.item_row_bg_color.value.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                              <!-- Product Row font Color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Font Color"
                                label-for="item_row_font_color"
                                :label-cols="5"
                              >
                                <!-- Color Picker -->
                                <b-input-group class="colorpicker-wrapper">
                                  <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    :value="inv_details.layout.item_row_font_color.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_28 }"
                                    v-model="inv_details.layout.item_row_font_color"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_28 = !colorPickerActive.color_28"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': inv_details.layout.item_row_font_color.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                           <!-- Item Description Fields -->

                          <b-row
                            class="my-2 ml-0"
                            :style="{'margin-bottom':colorPickerActive.color_29?'310px':colorPickerActive.color_28?'100px':colorPickerActive.color_27?'50px':'unset'}"
                          >
                            <b-col class="px-0">
                              <h6 class="mb-3 h6-lg text-link">Payment for</h6>
                              <!-- Item Description Font Size -->
                              <b-form-group
                                class="mb-4"
                                label="Font Size"
                                horizontal
                                label-for="pymt_font_size"
                                :label-cols="5"
                              >
                                <b-input-group append="pt">
                                  <b-form-input
                                    name="pymt_font_size"
                                    :class="{'is-invalid':inv_layout_has_error&&errors.has('inv_layout_prop_tab.pymt_font_size')}"
                                    v-validate="'min_value:0|max_value:18'"
                                    v-model="inv_details.layout.pymt_font_size"
                                  ></b-form-input>
                                </b-input-group>
                              </b-form-group>
                              <!-- Item Description Font Color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Font Color"
                                label-for="pymt_font_color"
                                :label-cols="5"
                              >
                                <!-- Color Picker -->
                                <b-input-group class="colorpicker-wrapper">
                                  <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    :value="inv_details.layout.pymt_font_color.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_29 }"
                                    v-model="inv_details.layout.pymt_font_color"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_29  = !colorPickerActive.color_29 "
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': inv_details.layout.pymt_font_color.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-form>
                      </b-tab>
                  </b-tabs>
                </b-tab>
                <!-- Total Tab -->
                <b-tab
                  title="Total"
                  class="px-pad py-3 mt-2 mr-4"
                  v-if="total_prop&&menu_id !=5 && menu_id !=10"
                >
                  <b-row class="ml-0">
                    <b-tabs
                      v-model="totalTabIndex"
                      class="nav-cols custom-line-tab button-nav button-tab"
                    >
                      <!-- Label Section -->
                      <b-tab title="Labels" class="px-0" active>
                        <b-form data-vv-scope="total_label_prop_tab">
                          <b-row class="mx-1 mt-4">
                            <b-col sm="12" class="px-1">
                              <!-- Show Total Section -->
                              <b-form-group>
                                <div class="abc-checkbox">
                                  <input
                                    type="checkbox"
                                    id="total_sec_show"
                                    :true-value="1"
                                    :false-value="0"
                                    v-model="total_prop.label.show_total_sec"
                                  />
                                  <label
                                    for="total_sec_show"
                                    style="padding-top:2px;"
                                  >Show Total Section</label>
                                </div>
                              </b-form-group>
                              <!-- Display Only Total section show -->
                              <div v-if="total_prop.label.show_total_sec==1">
                                <!-- Sub Total Field -->
                                <b-row class="my-3" v-if="menu_id!=15">
                                  <b-col sm="5" style="padding-top: 7px !important;">
                                    <!-- Show Sub Total -->
                                    <div class="abc-checkbox">
                                      <input
                                        type="checkbox"
                                        id="sub_total"
                                        :true-value="1"
                                        :false-value="0"
                                        v-model="total_prop.label.sub_total.show"
                                      />
                                      <label for="sub_total" style="padding-top:2px;">Sub Total</label>
                                    </div>
                                  </b-col>
                                  <b-col class="pl-2" sm="7">
                                    <!-- Sub Total Lable -->
                                    <b-form-input
                                      name="sub_total_label"
                                      :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.sub_total_label')}"
                                      v-validate="'max:50'"
                                      :disabled="total_prop.label.sub_total.show==0"
                                      v-model="total_prop.label.sub_total.label"
                                    ></b-form-input>
                                  </b-col>
                                </b-row>
                                <!-- TDS Setion -->

                                <b-form-group
                                  v-if="total_prop.label.shipping_charge&&menu_id!=15"
                                  class="pb-1"
                                  :label="'Shipping Charge'"
                                  horizontal
                                  label-for="shipping_charge"
                                  :label-cols="5"
                                >
                                  <b-form-input
                                    name="shipping_charge"
                                    :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.shipping_charge')}"
                                    v-validate="'max:50'"
                                    v-model="total_prop.label.shipping_charge"
                                  ></b-form-input>
                                </b-form-group>
                                <!-- Total Field -->
                                <b-form-group
                                  class="pb-1"
                                  label="Total"
                                  horizontal
                                  label-for="total"
                                  :label-cols="5"
                                >
                                  <b-form-input
                                    name="total_label"
                                    :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.total_label')}"
                                    v-validate="'max:50'"
                                    v-model="total_prop.label.total"
                                  ></b-form-input>
                                </b-form-group>
                                <!-- Show Discount Field -->
                                <b-form-group class="mb-3" v-if="menu_id!=15">
                                  <div class="abc-checkbox">
                                    <input
                                      type="checkbox"
                                      id="discount"
                                      :true-value="1"
                                      :false-value="0"
                                      v-model="total_prop.label.show_discount"
                                    />
                                    <label for="discount" style="padding-top:2px;">Discount</label>
                                  </div>
                                </b-form-group>
                                <b-row
                                  class="my-3"
                                  v-if="total_prop.label.hasOwnProperty('total_tax_amt')"
                                >
                                  <b-col sm="5" style="padding-top: 7px !important;">
                                    <!-- Show Total Taxable Amount-->
                                    <div class="abc-checkbox">
                                      <input
                                        type="checkbox"
                                        id="total_tax_amt"
                                        :true-value="1"
                                        :false-value="0"
                                        v-model="total_prop.label.total_tax_amt.show"
                                      />
                                      <label
                                        for="total_tax_amt"
                                        style="padding-top:2px;"
                                      >Total Taxable Amount</label>
                                    </div>
                                  </b-col>
                                  <b-col class="pl-2" sm="7">
                                    <!-- Total Taxable Amount Lable -->
                                    <b-form-input
                                      name="total_tax_amt_label"
                                      :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.total_tax_amt')}"
                                      v-validate="'max:50'"
                                      :disabled="total_prop.label.total_tax_amt.show==0"
                                      v-model="total_prop.label.total_tax_amt.label"
                                    ></b-form-input>
                                  </b-col>
                                </b-row>
                                <b-form-group
                                  label="Currency Symbol"
                                  label-cols="6"
                                  label-for="currency_syb"
                                  v-if="total_prop.label.currency_syb"
                                >
                                  <b-form-radio-group
                                    :options="[{value:1,text:'Before amount'},{value:2,text:'After amount'}]"
                                    v-model="total_prop.label.currency_syb"
                                  ></b-form-radio-group>
                                </b-form-group>
                                <b-form-group v-if="menu_id!=15">
                                  <div
                                    class="abc-checkbox mb-2"
                                    v-if="total_prop.label.hasOwnProperty('show_total_qty')"
                                  >
                                    <input
                                      type="checkbox"
                                      id="show_total_qty"
                                      :true-value="1"
                                      :false-value="0"
                                      v-model="total_prop.label.show_total_qty"
                                    />
                                    <label for="show_total_qty" style="padding-top:2px;">Quantity</label>
                                  </div>
                                  <b-form-group
                                    v-if="total_prop.label.show_total_qty==1&&total_prop.label.hasOwnProperty('item_in_total')&&menu_id!=15"
                                    class="pb-1"
                                    :label="'Items in Total'"
                                    horizontal
                                    label-for="item_in_total"
                                    :label-cols="5"
                                  >
                                    <b-form-input
                                      name="item_in_total"
                                      :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.item_in_total')}"
                                      v-validate="'max:50'"
                                      v-model="total_prop.label.item_in_total"
                                    ></b-form-input>
                                  </b-form-group>
                                </b-form-group>
                                <div v-if="menu_id==1||menu_id==3 || menu_id == 8||menu_id==15">
                                  <!-- Show Payment Details -->
                                  <b-form-group class="mt-5">
                                    <div class="abc-checkbox">
                                      <input
                                        type="checkbox"
                                        id="show_pay_detail"
                                        :true-value="1"
                                        :false-value="0"
                                        v-model="total_prop.label.show_pay_detail"
                                      />
                                      <label
                                        for="show_pay_detail"
                                        style="padding-top:2px;"
                                      >Show Payment Details</label>
                                    </div>
                                  </b-form-group>
                                  <!-- Payment Details -->
                                  <div v-if="total_prop.label.show_pay_detail==1">
                                    <!-- Payment Made -->
                                    <b-form-group
                                      class="pb-1"
                                      :label="menu_id==3?'Credit Used':'Payment Made'"
                                      horizontal
                                      label-for="pay_made"
                                      :label-cols="5"
                                    >
                                      <b-form-input
                                        name="pay_made_label"
                                        :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.pay_made_label')}"
                                        v-validate="'max:50'"
                                        v-model="total_prop.label.pay_made"
                                      ></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                      v-if="total_prop.label.hasOwnProperty('amt_withheld')&&menu_id!=15"
                                      class="pb-1"
                                      :label="'Amount Withheld'"
                                      horizontal
                                      label-for="amt_withheld"
                                      :label-cols="5"
                                    >
                                      <b-form-input
                                        name="amt_withheld"
                                        :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.amt_withheld')}"
                                        v-validate="'max:50'"
                                        v-model="total_prop.label.amt_withheld"
                                      ></b-form-input>
                                    </b-form-group>
                                    <!-- Credits Applied -->
                                    <b-form-group
                                      class="pb-1"
                                      :label="menu_id==3?'Refund':'Credits Applied'"
                                      horizontal
                                       v-if="menu_id!=15"
                                      label-for="credit_apply"
                                      :label-cols="5"
                                    >
                                      <b-form-input
                                        name="credit_apply_label"
                                        :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.credit_apply_label')}"
                                        v-validate="'max:50'"
                                        v-model="total_prop.label.credits_apply"
                                      ></b-form-input>
                                    </b-form-group>
                                    <!-- Writeoff amount -->
                                    <b-form-group
                                      class="pb-1"
                                      :label="'Write Off Amount'"
                                      horizontal
                                      label-for="writeoff_amt"
                                      :label-cols="5"
                                      v-if="menu_id==1"
                                    >
                                      <b-form-input
                                        name="writeoff_amt"
                                        :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.writeoff_amt')}"
                                        v-validate="'max:50'"
                                        v-model="total_prop.label.writeoff_amt_label"
                                      ></b-form-input>
                                    </b-form-group>
                                     <!-- Refund -->
                                      <b-form-group
                                      v-if="menu_id==15"
                                      class="pb-1"
                                      label="Refund"
                                      horizontal
                                      label-for="refund"
                                      :label-cols="5"
                                    >
                                      <b-form-input
                                        name="refund_label"
                                        :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.refund_label')}"
                                        v-validate="'max:50'"
                                        v-model="total_prop.label.refund"
                                      ></b-form-input>
                                    </b-form-group>

                                    <!-- Balance Due -->
                                    <b-form-group
                                      class="pb-1"
                                      :label="menu_id==3?'Credits Remaining':'Balance Due'"
                                      horizontal
                                      label-for="bal_due"
                                      :label-cols="5"
                                    >
                                      <b-form-input
                                        name="bal_due_label"
                                        :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.bal_due_label')}"
                                        v-validate="'max:50'"
                                        v-model="total_prop.label.bal_due"
                                      ></b-form-input>
                                    </b-form-group>
                                  </div>
                                </div>
                              </div>
                              <!-- Show amount in words -->
                              <b-form-group class="mt-5">
                                <div class="abc-checkbox">
                                  <input
                                    type="checkbox"
                                    id="show_amt_word"
                                    :true-value="1"
                                    :false-value="0"
                                    v-model="total_prop.label.show_amt_wrd"
                                  />
                                  <label
                                    for="show_amt_word"
                                    style="padding-top:2px;"
                                  >Show Amount in Words</label>
                                </div>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-form>
                      </b-tab>
                      <!-- Layout Details -->
                      <b-tab title="Layout">
                        <b-form data-vv-scope="total_layout_prop_tab">
                          <b-row class="mb-2 mt-4 ml-0">
                            <b-col class="px-0">
                              <!-- Sub total and tax Layouts -->
                              <h6 class="mb-3 h6-lg text-link">{{menu_id!=15?'Total(Subtotal, Tax)':'Total(Total, Payment Made,Refund)'}}</h6>
                              <b-form-group
                                class="mb-4"
                                label="Font Size"
                                horizontal
                                label-for="total_font_size"
                                :label-cols="5"
                              >
                                <b-input-group append="pt">
                                  <b-form-input
                                    name="total_font_size"
                                    :class="{'is-invalid':total_layout_has_error&&errors.has('total_layout_prop_tab.total_font_size')}"
                                    v-validate="'min_value:0|max_value:18'"
                                    v-model="total_prop.layout.total_font_size"
                                  ></b-form-input>
                                </b-input-group>
                              </b-form-group>
                              <!-- Background Color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Background Color"
                                label-for="total_bg_color"
                                :label-cols="5"
                              >
                                <!-- Color Picker -->
                                <b-input-group class="colorpicker-wrapper">
                                  <!-- Apply Background Color -->
                                  <div class="abc-checkbox" style="padding-top:5px;">
                                    <input
                                      type="checkbox"
                                      id="total_bg_color"
                                      :true-value="1"
                                      :false-value="0"
                                      v-model="total_prop.layout.total_bg_color.show"
                                    />
                                    <label for="total_bg_color"></label>
                                  </div>
                                  <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    :value="total_prop.layout.total_bg_color.value.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_9  }"
                                    v-model="total_prop.layout.total_bg_color.value"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_9 = !colorPickerActive.color_9"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': total_prop.layout.total_bg_color.value.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                              <!-- Font Color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Font Color"
                                label-for="total_font_color"
                                :label-cols="5"
                              >
                                <!-- Color Picker -->
                                <b-input-group class="colorpicker-wrapper">
                                  <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    :value="total_prop.layout.total_font_color.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_10 }"
                                    v-model="total_prop.layout.total_font_color"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_10 = !colorPickerActive.color_10"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': total_prop.layout.total_font_color.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                          <!-- Balance Due Details -->
                          <b-row
                            class="my-2 ml-0"
                            :style="{'margin-bottom':colorPickerActive.color_12?'310px':colorPickerActive.color_11?'250px':colorPickerActive.color_10?'80px':colorPickerActive.color_9?'50px':'unset'}"
                          >
                            <b-col class="px-0" style="padding-top: 7px !important;">
                              <h6
                                class="mb-3 h6-lg text-link"
                              >{{menu_id==2?'Total':menu_id==3?'Credits Remaining':'Balance Due'}}</h6>
                              <!-- Font Size -->
                              <b-form-group
                                class="mb-4"
                                label="Font Size"
                                horizontal
                                label-for="due_font_size"
                                :label-cols="5"
                              >
                                <b-input-group append="pt">
                                  <b-form-input
                                    name="due_font_size"
                                    :class="{'is-invalid':total_layout_has_error&&errors.has('total_layout_prop_tab.due_font_size')}"
                                    v-validate="'min_value:0|max_value:18'"
                                    v-model="total_prop.layout.due_font_size"
                                  ></b-form-input>
                                </b-input-group>
                              </b-form-group>
                              <!-- Balance Due background Color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Background Color"
                                label-for="bal_bg_color"
                                :label-cols="5"
                              >
                                <b-input-group class="colorpicker-wrapper">
                                  <!-- Apply Background  -->
                                  <div class="abc-checkbox" style="padding-top:5px;">
                                    <input
                                      type="checkbox"
                                      id="due_bg_color"
                                      :true-value="1"
                                      :false-value="0"
                                      v-model="total_prop.layout.due_bg_color.show"
                                    />
                                    <label for="due_bg_color"></label>
                                  </div>
                                  <!-- Color Picker -->
                                  <input
                                    type="text"
                                    class="form-control"
                                    :value="total_prop.layout.due_bg_color.value.hex"
                                    disabled
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_11 }"
                                    v-model="total_prop.layout.due_bg_color.value"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_11 = !colorPickerActive.color_11"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': total_prop.layout.due_bg_color.value.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                              <!-- Balance Due Font color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Font Color"
                                label-for="due_font_color"
                                :label-cols="5"
                              >
                                <b-input-group class="colorpicker-wrapper">
                                  <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    :value="total_prop.layout.due_font_color.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_12 }"
                                    v-model="total_prop.layout.due_font_color"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_12 = !colorPickerActive.color_12"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': total_prop.layout.due_font_color.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-form>
                      </b-tab>
                    </b-tabs>
                  </b-row>
                </b-tab>
                <!-- Footer Tab -->
                <b-tab title="Footer" class="px-pad py-3 mt-2 mr-4" v-if="footer_prop">
                  <!-- Notes Details -->
                  <b-form data-vv-scope="footer_prop_tab">
                    <template v-if="menu_id !=5&&footer_prop.hasOwnProperty('note_font_size')">
                      <b-row class="mb-2 ml-0">
                        <b-col class="px-0" style="padding-top: 7px !important;">
                          <h6 class="mb-3 h6-lg text-link">Notes</h6>
                          <!-- Note Font Size -->
                          <b-form-group
                            class="mb-4"
                            label="Font Size"
                            horizontal
                            label-for="note_font_size"
                            :label-cols="5"
                          >
                            <b-input-group append="pt">
                              <b-form-input
                                name="note_font_size"
                                :class="{'is-invalid':footer_has_error&&errors.has('footer_prop_tab.note_font_size')}"
                                v-validate="'min_value:0|max_value:18'"
                                v-model="footer_prop.note_font_size"
                              ></b-form-input>
                            </b-input-group>
                          </b-form-group>
                          <b-form-group
                            v-if="footer_prop.hasOwnProperty('note_label')"
                            class="mb-4"
                            label="Label"
                            horizontal
                            label-for="note_label"
                            :label-cols="5"
                          >
                            <b-form-input
                              name="note_label"
                              :class="{'is-invalid':footer_has_error&&errors.has('footer_prop_tab.note_label')}"
                              v-validate="'max:50'"
                              v-model="footer_prop.note_label"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <!-- Terms and Condition Details -->
                      <b-row class="my-2 ml-0" v-if="menu_id !=10&&footer_prop.hasOwnProperty('show_term_con')">
                        <b-col class="px-0" style="padding-top: 7px !important;">
                          <h6 class="mb-3 h6-lg text-link">Terms & Conditions</h6>
                          <!-- Show Terms and Condition Details -->
                          <b-row class="my-2 ml-0">
                            <b-col class="px-0" style="padding-top: 7px !important;">
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="show_term"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="footer_prop.show_term_con"
                                />
                                <label
                                  for="show_term"
                                  style="padding-top:2px;"
                                >Show Terms & Conditions</label>
                              </div>
                            </b-col>
                          </b-row>
                          <!-- Term and condtions Label -->
                          <b-form-group
                            class="mb-4"
                            horizontal
                            label="Label"
                            label-for="term_label"
                            :label-cols="5"
                            v-if="footer_prop.hasOwnProperty('term_label')"
                          >
                            <b-form-input
                              name="term_label"
                              :class="{'is-invalid':footer_has_error&&errors.has('footer_prop_tab.term_label')}"
                              v-validate="'max:50'"
                              v-model="footer_prop.term_label"
                            ></b-form-input>
                          </b-form-group>
                          <!-- Terms and condtions font size -->
                          <b-form-group
                            class="mb-4"
                            label="Font Size"
                            horizontal
                            label-for="term_font_size"
                            :label-cols="5"
                            v-if="footer_prop.hasOwnProperty('term_font_size')"
                          >
                            <b-input-group append="pt">
                              <b-form-input
                                name="term_font_size"
                                :class="{'is-invalid':footer_has_error&&errors.has('footer_prop_tab.term_font_size')}"
                                v-validate="'min_value:0|max_value:18'"
                                v-model="footer_prop.term_font_size"
                              ></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <!-- Signature Details -->
                      <b-row class="my-2 ml-0" v-if="menu_id !=10&&footer_prop.hasOwnProperty('signature')">
                        <b-col class="px-0" style="padding-top: 7px !important;">
                          <h6 class="mb-3 h6-lg text-link">Signature</h6>
                          <!-- Show Signature Details -->
                          <b-row class="my-2 ml-0">
                            <b-col class="px-0" style="padding-top: 7px !important;">
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="show_sign"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="footer_prop.signature.show"
                                />
                                <label for="show_sign" style="padding-top:2px;">Show Signature</label>
                              </div>
                            </b-col>
                          </b-row>
                          <!-- Signature Label -->
                          <b-form-group
                            class="mb-4"
                            horizontal
                            label="Label"
                            label-for="sign_label"
                            :label-cols="5"
                          >
                            <b-form-input
                              name="sign_label"
                              :class="{'is-invalid':footer_has_error&&errors.has('footer_prop_tab.sign_label')}"
                              v-validate="'max:50'"
                              v-model="footer_prop.signature.label"
                            ></b-form-input>
                          </b-form-group>
                          <b-form-group
                            class="mb-4"
                            horizontal
                            label="Name"
                            label-for="sign_name"
                            :label-cols="5"
                          >
                            <b-form-input
                              name="sign_name"
                              :class="{'is-invalid':footer_has_error&&errors.has('footer_prop_tab.sign_name')}"
                              v-validate="'max:50'"
                              v-model="footer_prop.signature.name"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row class="my-2 ml-0" v-if="footer_prop.hasOwnProperty('add_signature')">
                        <b-col class="px-0" style="padding-top: 7px !important;">
                          <h6 class="mb-3 h6-lg text-link">Additional Signature</h6>
                          <!-- Show Signature Details -->
                          <b-row class="my-2 ml-0">
                            <b-col class="px-0" style="padding-top: 7px !important;">
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="show_add_sign"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="footer_prop.add_signature.show"
                                />
                                <label
                                  for="show_add_sign"
                                  style="padding-top:2px;"
                                >Show Additional Signature</label>
                              </div>
                            </b-col>
                          </b-row>
                          <!-- Signature Label -->
                          <b-form-group
                            class="mb-4"
                            horizontal
                            label="Label"
                            label-for="add_sign_label"
                            :label-cols="5"
                          >
                            <b-form-input
                              name="add_sign_label"
                              :class="{'is-invalid':footer_has_error&&errors.has('footer_prop_tab.add_sign_label')}"
                              v-validate="'max:50'"
                              v-model="footer_prop.add_signature.label"
                            ></b-form-input>
                          </b-form-group>
                          <b-form-group
                            class="mb-4"
                            horizontal
                            label="Name"
                            label-for="add_sign_name"
                            :label-cols="5"
                          >
                            <b-form-input
                              name="add_sign_name"
                              :class="{'is-invalid':footer_has_error&&errors.has('footer_prop_tab.add_sign_name')}"
                              v-validate="'max:50'"
                              v-model="footer_prop.add_signature.name"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </template>
                    <!-- Footer Details -->
                    <b-row class="my-2 ml-0">
                      <b-col class="px-0" style="padding-top: 7px !important;">
                        <h6 class="mb-3 h6-lg text-link">Footer</h6>
                        <!-- Customer Name Color -->
                        <b-form-group
                          v-if="footer_prop.hasOwnProperty('footer_color')"
                          horizontal
                          label="Font Color"
                          label-for="footer_color"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <input
                              type="text"
                              class="form-control"
                              :value="footer_prop.footer_color.hex"
                              disabled
                            />
                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_16 }"
                              v-model="footer_prop.footer_color"
                            />
                            <b-input-group-text
                              style="padding:5px !important;"
                              @click="colorPickerActive.color_16 = !colorPickerActive.color_16"
                              slot="append"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': footer_prop.footer_color.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>

                        <!-- Customer name font -->
                        <b-form-group
                          v-if="footer_prop.hasOwnProperty('footer_font_size')"
                          horizontal
                          label="Font Size"
                          label-for="footer_font_size"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-input-group append="pt">
                            <b-form-input
                              name="footer_font_size"
                              :class="{'is-invalid':header_has_error&&errors.has('footer_prop_tab.footer_font_size')}"
                              v-validate="'min_value:0|max_value:18'"
                              v-model="footer_prop.footer_font_size"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                        <!-- Footer Backgroud Color -->
                        <b-form-group
                          class="mb-4"
                          horizontal
                          label="Background Color"
                          label-for="footer_bg"
                          :label-cols="5"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <!-- Apply Background -->
                            <div class="abc-checkbox" style="padding-top:5px;">
                              <input
                                type="checkbox"
                                id="footer_bg_color"
                                :true-value="1"
                                :false-value="0"
                                v-model="footer_prop.bg_color.show"
                              />
                              <label for="footer_bg_color"></label>
                            </div>
                            <!-- Color Picker -->
                            <input
                              type="text"
                              class="form-control"
                              :value="footer_prop.bg_color.value.hex"
                              disabled
                            />
                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_13 }"
                              v-model="footer_prop.bg_color.value"
                            />
                            <b-input-group-text
                              @click="colorPickerActive.color_13 = !colorPickerActive.color_13"
                              slot="append"
                              style="padding:5px !important;"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': footer_prop.bg_color.value.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-tab>
              </b-tabs>
              <!-- Footer for Template settings -->
              <div style="position:fixed;bottom:0;width: 400px;" class="border-top">
                <b-button
                  @click="onSubmit()"
                  size="sm"
                  variant="primary"
                  class="btn-rounded mx-mar my-2"
                >Save</b-button>
              </div>
            </div>
          </div>
        </b-nav>
      </div>
      <div class="sidenave-main-content" style="margin-top:-17px;">
        <b-row class="px-3 border-bottom" style="height:42px;">
          <b-col cols="10" class="px-0">
            <b-button
              @click="preview()"
              size="sm"
              variant="light"
              class="mr-2 mt-1 text-link btn-rounded"
            >
              Preview
              <span>
                <i class="la la-eye la-lg"></i>
              </span>
            </b-button>
            <b-button
              v-b-modal.restoreSettings
              size="sm"
              variant="light"
              class="text-link btn-rounded mt-1"
            >Restore Default</b-button>
          </b-col>
          <b-col cols="2" class="text-right px-0">
            <a @click="redirectPage()" class="mr-2 text-right">
              <i class="la la-remove la-lg text-decoration-none mt-3"></i>
            </a>
          </b-col>
        </b-row>

        <div
          class="sidenav-view-block py-4"
          style="overflow-y: scroll;height: calc(100vh -112px);margin-left: -20px !important;margin-right: -20px !important;"
        >
          <StandardTemplate
            :list="list"
            :id="id"
            v-if="$route.params.id == 18||$route.params.id == 1||$route.params.id == 4||$route.params.id == 15||$route.params.id==8||$route.params.id==11||$route.params.id == 14||$route.params.id == 16||$route.params.id == 17||$route.params.id == 19"
          ></StandardTemplate>
          <SpreadSheetTemplate
            :list="list"
            :id="id"
            v-if="$route.params.id == 2||$route.params.id == 5||$route.params.id==9||$route.params.id==12"
          ></SpreadSheetTemplate>
          <Payments
            :list="list"
            :id="id"
            v-if="$route.params.id == 21||$route.params.id == 23"
          ></Payments>
            <PaymentsRetail
            :list="list"
            :id="id"
            v-if="$route.params.id == 28 || $route.params.id == 29"
          ></PaymentsRetail>
             <CustomerDeposit
            :list="list"
            :id="id"
            v-if="$route.params.id == 26"
          ></CustomerDeposit>

        </div>
      </div>
    </div>
    <!-- modal for restore settings  -->
    <b-modal
      id="restoreSettings"
      title="Restore Default Settings"
      cancel-title="No"
      cancel-variant="light"
      ok-title="Yes"
      @ok="backtodefault()"
    >
      <p>Are you sure you want to restore default settings?</p>
    </b-modal>
  </div>
</template>
 
 <script>
import Vue from "vue";
import { mapState } from "vuex";
import { Sketch } from "vue-color";
import bFormSlider from "vue-bootstrap-slider"; // Slider
import StandardTemplate from "@/components/Form/Settings/Print/Invoice/StandardTemplate";
import SpreadSheetTemplate from "@/components/Form/Settings/Print/Invoice/SpreadSheetTemplate";
import Payments from "@/components/Form/Settings/Print/Invoice/Payments";
import CustomerDeposit from "@/components/Form/Settings/Print/Invoice/CustomerDeposit";
import PaymentsRetail from "@/components/Form/Settings/Print/Invoice/PaymentsRetail";

import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
Vue.use(bFormSlider); // Use silder
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import store from "@/store/index";
export default {
  mixins: [notificationMixin], // call the glbal mixin fucntion
  components: {
    Sketch,
    StandardTemplate,
    SpreadSheetTemplate,
    Payments,
    CustomerDeposit,
    PaymentsRetail
  },
  props: ["id", "path"],
  data() {
    return {
      // color picker value for display
      colorPickerActive: {
        color_1: false,
        color_2: false,
        color_3: false,
        color_4: false,
        color_5: false,
        color_6: false,
        color_7: false,
        color_8: false,
        color_9: false,
        color_10: false,
        color_11: false,
        color_12: false,
        color_13: false,
        color_14: false,
        color_15: false,
        color_16: false,
        color_17: false,
        color_18: false,
        color_19: false,
        color_20: false,
        color_21: false,
        color_22: false,
        color_23: false,
        color_24: false,
        color_25: false,
        color_26: false,
        color_27: false,
        color_28: false,
        color_29: false,
      },
      // Paper size options
      papersize: [
        {
          text: "A4",
          value: "0",
        },
        {
          text: "A5",
          value: "1",
        },
        // {
        //   text: "Letter",
        //   value: "2"
        // }
      ],
      // Orientation options
      orientation: [
        {
          text: "Portrait",
          value: "0",
        },
        {
          text: "Landscape",
          value: "1",
        },
      ],
      tabIndex: 0,
      itemTabIndex: 0,
      invTabIndex: 0,
      totalTabIndex: 0,
      temp_has_error: false,
      header_has_error: false,
      item_label_has_error: false,
      item_layout_has_error: false,
      total_label_has_error: false,
      total_layout_has_error: false,
      receipt_has_error: false,
      inv_label_has_error: false,
      inv_layout_has_error: false,
      footer_has_error: false,
      isValidMarginWidth: "",
      isValidMarginHeight: "",
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center", // notification design class
    };
  },

  methods: {
    redirectPage() {
      if (this.path) {
        this.$router.push(this.path);
      } else {
        this.$router.push({
          name: "Templates",
          query: {
            stg_menu: this.$route.query.stg_menu,
            template_group:
              this.$route.query.stg_menu == "Sales Order"
                ? "sales_order"
                : this.$route.query.stg_menu == "Package"
                ? "package"
                : this.$route.query.stg_menu == "Shipment"
                ? "shipment"
                : this.$route.query.stg_menu == "Invoice"
                ? "invoice"
                : this.$route.query.stg_menu == "Sales"
                ? "quotation"
                : this.$route.query.stg_menu == "Credit Note"
                ? "creditnote"
                : this.$route.query.stg_menu == "Purchase Order"
                ? "purchase_order"
                : this.$route.query.stg_menu == "Customer deposit"
                ? "customerdeposit"
                : this.$route.query.stg_menu == "Bill"
                ? "bill"
                : this.$route.query.stg_menu == "Vendor Credits"
                      ? "vendorcredit":this.$route.query.stg_menu == "Payments Received"
                      ? "paymentreceived":this.$route.query.stg_menu == "Customer Advance"
                      ? "customeradvance"
                      : this.$route.query.template_group,
          },
        });
      }
    },
    // preview print template
    preview() {
      this.validateForm().then((result) => {
        if (
          result &&
          this.isValidMarginWidth == false &&
          this.isValidMarginHeight == false
        ) {
          EventBus.$emit("preview", this.list);
        }
      });
    },
    // validate paper size with margins
    validatePaperSize() {
      // Selected Paper width
      var paper_width =
        this.temp_prop.paper_size == 0
          ? this.temp_prop.orientation == 0
            ? 21
            : 29.7
          : this.temp_prop.orientation == 0
          ? 14.8
          : 21;
      // Selected paper height
      var paper_height =
        this.temp_prop.paper_size == 0
          ? this.temp_prop.orientation == 0
            ? 29.7
            : 21
          : this.temp_prop.orientation == 0
          ? 21
          : 14.8;
      // Total margins(left and right)
      var margin_width =
        this.temp_prop.margin_left / 0.3937 +
        this.temp_prop.margin_right / 0.3937;
      // Total margins (top and bottom)
      var margin_height =
        this.temp_prop.margin_top / 0.3937 +
        this.temp_prop.margin_bottom / 0.3937;
      // check valid margin width
      this.isValidMarginWidth = paper_width < margin_width;
      // check valid margin height
      this.isValidMarginHeight = paper_height < margin_height;
    },
    // validate form details
    async validateForm() {
      // Validate paper size with given margins

      this.validatePaperSize();
      var validated = false;
      // Validate Form template Form
      return new Promise((resolve, reject) => {
        this.$validator
          .validateAll("temp_prop_tab")
          .then((result) => {
            if (
              result == false ||
              this.isValidMarginWidth ||
              this.isValidMarginHeight
            ) {
              this.tabIndex = 0;
              // Display margin validation error
              if (this.isValidMarginWidth || this.isValidMarginHeight) {
                // Display error notification
                window.Messenger().post({
                  extraClasses:
                    "messenger-fixed messenger-on-top messenger-on-center",
                  message: this.isValidMarginWidth
                    ? "The sum of left and right margins is more than the width of the selected paper"
                    : "The sum of top and bottom margins is more than the height of the selected paper",
                  type: "danger",
                  showCloseButton: true,
                });
              }
              // Validation Error
              this.temp_has_error = true;
            } else {
              this.temp_has_error = false;
              // Validate Header tab Form
              this.$validator.validateAll("header_prop_tab").then((result) => {
                if (result == false) {
                  this.tabIndex = 1;
                  this.header_has_error = true;
                } else {
                  this.header_has_error = false;
                  // Validate Iteam Tab Label form
                  this.$validator
                    .validateAll("item_label_prop_tab")
                    .then((result) => {
                      if (result == false) {
                        this.tabIndex = 2;
                        this.itemTabIndex = 0;
                        this.item_label_has_error = true;
                      } else {
                        this.item_label_has_error = false;
                        // Validate Iteam Tab Layout form
                        this.$validator
                          .validateAll("item_layout_prop_tab")
                          .then((result) => {
                            if (result == false) {
                              this.tabIndex = 2;
                              this.itemTabIndex = 1;
                              this.item_layout_has_error = true;
                            } else {
                              this.item_layout_has_error = false;
                              // Validate Total Tab Label form
                              this.$validator
                                .validateAll("total_label_prop_tab")
                                .then((result) => {
                                  if (result == false) {
                                    this.tabIndex = 3;
                                    this.totalTabIndex = 0;
                                    this.total_label_has_error = true;
                                  } else {
                                    this.total_label_has_error = false;
                                    // Validate Total Tab Layout form
                                    this.$validator
                                      .validateAll("total_layout_prop_tab")
                                      .then((result) => {
                                        if (result == false) {
                                          this.tabIndex = 3;
                                          this.totalTabIndex = 1;
                                          this.total_layout_has_error = true;
                                        } else {
                                          this.total_layout_has_error = false;
                                          this.$validator
                                            .validateAll("receipt_prop_tab")
                                            .then((result) => {
                                              if (result == false) {
                                                this.tabIndex = 2;
                                                this.receipt_has_error = true;
                                              } else {
                                                this.receipt_has_error = false;
                                                this.$validator
                                                  .validateAll(
                                                    "inv_label_prop_tab"
                                                  )
                                                  .then((result) => {
                                                    if (result == false) {
                                                      this.tabIndex = 3;
                                                      this.invTabIndex = 0;
                                                      this.inv_label_has_error = true;
                                                    } else {
                                                      this.inv_label_has_error = false;
                                                      this.$validator
                                                        .validateAll(
                                                          "inv_layout_prop_tab"
                                                        )
                                                        .then((result) => {
                                                          if (result == false) {
                                                            this.tabIndex = 3;
                                                            this.invTabIndex = 1;
                                                            this.inv_layout_has_error = true;
                                                          } else {
                                                            this.inv_layout_has_error = false;
                                                            // Validate Footer Tab form
                                                            this.$validator
                                                              .validateAll(
                                                                "footer_prop_tab"
                                                              )
                                                              .then(
                                                                (result) => {
                                                                  if (
                                                                    result ==
                                                                    false
                                                                  ) {
                                                                    this.tabIndex = 4;
                                                                    this.footer_has_error = true;
                                                                  } else {
                                                                    this.footer_has_error = false;
                                                                    validated = true;
                                                                    resolve(
                                                                      validated
                                                                    );
                                                                  }
                                                                }
                                                              );
                                                          }
                                                        });
                                                    }
                                                  });
                                              }
                                            });
                                        }
                                      });
                                  }
                                });
                            }
                          });
                      }
                    });
                }
              });
            }
          })
          .catch(() => {
            reject("false");
          });
      });
    },
    backtodefault() {
      this.list = JSON.parse(JSON.stringify(this.default_list));
      this.preview();
    },
    // Submit action
    onSubmit() {
      this.validateForm().then((result) => {
        if (
          result &&
          this.isValidMarginWidth == false &&
          this.isValidMarginHeight == false
        ) {
          var data = JSON.stringify({
            list: {
              template_list: this.list,
            },
          });
          this.$store
            .dispatch("settings/updateprintsettings", {
              id: this.$route.params.id,
              data: data,
            })
            .then(() => {
              this.$router.push({
                name: "Templates",
                query: {
                  stg_menu: this.$route.query.stg_menu,
                  template_group:
                    this.$route.query.stg_menu == "Sales Order"
                      ? "sales_order"
                      : this.$route.query.stg_menu == "Package"
                      ? "package"
                      : this.$route.query.stg_menu == "Shipment"
                      ? "shipment"
                      : this.$route.query.stg_menu == "Invoice"
                      ? "invoice"
                      : this.$route.query.stg_menu == "Sales"
                      ? "quotation"
                      : this.$route.query.stg_menu == "Credit Note"
                      ? "creditnote"
                      : this.$route.query.stg_menu == "Purchase Order"
                      ? "purchase_order"
                      : this.$route.query.stg_menu == "Bill"
                      ? "bill"
                      : this.$route.query.stg_menu == "Vendor Credits"
                      ? "vendorcredit":this.$route.query.stg_menu == "Payments Received"
                      ? "paymentreceived":this.$route.query.stg_menu == "Customer Advance"
                      ? "customeradvance"
                      : this.$route.query.template_group,
                },
              });
              window.Messenger().post({
                extraClasses:
                  "messenger-fixed messenger-on-top messenger-on-center",
                message: " Template has been updated successfully",
                type: "success",
                showCloseButton: true,
              });
            });
        }
      });
    },
    // Find Logo height by width (height=width*1.22/2)
    findHieght(value) {
      this.header_prop.logo_height = value.newValue * (1.22 / 2);
    },
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store
      .dispatch(
        "settings/fetchprintsettings",
        JSON.stringify({
          id: routeTo.params.id,
        })
      )
      .then(() => {
        next();
      });
  },
  computed: {
    list: {
      get() {
        return this.$store.state.settings.template_list;
      },
      set(val) {
        this.$store.state.settings.template_list = val;
      },
    },

    ...mapState({
      default_list: (state) => state.settings.default_template_list,
      temp_prop: (state) => state.settings.template_list.temp_prop || "",
      header_prop: (state) => state.settings.template_list.header_prop || "",
      item_prop: (state) => state.settings.template_list.item_prop || "",
      total_prop: (state) => state.settings.template_list.total_prop || "",
      footer_prop: (state) => state.settings.template_list.footer_prop || "",
      receipt_info: (state) => state.settings.template_list.receipt_info || "",
      inv_details: (state) => state.settings.template_list.inv_details || "",
      menu_id: (state) => state.settings.template_list.menu_id,
    }),
  },
};
</script>
<style>
.print-temp .input-group input {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-right: 0 !important;
}
.print-temp .input-group .input-group-append .input-group-text {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border: 1px solid #dadada !important;
  padding: 5px 9px;
}
.print-temp .custom-line-tab .nav-tabs > .nav-item .nav-link.active {
  border-bottom: 2px solid #0675b9 !important;
}
.print-temp .d-inline-block {
  margin: 6px;
}
.forms-elements .colorpicker-wrapper .colorpicker {
  top: 40px !important;
}
.vertical-sidenav.sidenav-container-layout .sidenave-main-content {
  float: right;
  width: calc(100% - 400px);
}
</style>
